// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:34:06.349Z
// Property: Silver Springs Apts. (ID: 6767906449166549)
// Collections: 26 amenities, 3 floorplans (live), 19 photos, 74 POIs, 4 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449166549",
  "property_external_id": "48303",
  "property_zillow_url": "https://www.zillow.com/apartments/wichita-ks/silver-springs-apts./5XtP76/",
  "property_apartments_url": "none",
  "property_google_business_url": "https://www.google.com/maps/place/Silver+Springs+Apartments/data=!4m2!3m1!1s0x0:0x68190d97ba66459a?sa=X&ved=2ahUKEwjMjeLEhL2SAxUWnCYFHbMGDUwQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "31277355030",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "silver-springs-apts.",
  "property_name": "Silver Springs Apts.",
  "property_website_url": "https://www.caseusa.com/apartments/ks/wichita/silver-springs/",
  "property_domain": null,
  "property_address": "999 North Silver Springs Blvd",
  "property_full_address": "999 North Silver Springs Blvd, Wichita, KS, 67212",
  "property_address_1": "999 North Silver Springs Blvd",
  "property_address_2": null,
  "property_address_city": "Wichita",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "67212",
  "property_address_country": "US",
  "property_address_county": "Sedgwick County",
  "property_neighborhood_address": null,
  "property_address_latitude": "37.6993",
  "property_address_longitude": "-97.4252",
  "property_email": "silversprings@caseusa.com",
  "property_phone": "(316) 251-9950",
  "property_call_tracking_phone": "855-481-1546",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Silver Springs in Wichita, KS, where modern living meets comfort. Choose from spacious studio, one-bedroom, or two-bedroom floor plans, each designed for your lifestyle. Enjoy amenities like a tropical pool, clubhouse, and serene walking trails. Ready to find your new home? Browse availability or schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Silver Springs, your ideal destination for comfortable living in the heart of Wichita, KS. Our thoughtfully designed apartment community offers a variety of floor plans, including inviting Studios, spacious One-Bedrooms, and family-friendly Two-Bedrooms. Each apartment is equipped with modern amenities, such as fully equipped kitchens, ceiling fans, and walk-in closets, ensuring a lifestyle of convenience and comfort.\n\nAt Silver Springs, you'll enjoy an array of exceptional community amenities. Unwind by our indoor tropical pool or soak up the sun on the sundeck. Enjoy leisurely afternoons at our BBQ & picnic area or take a stroll along the scenic walking trails surrounding our picturesque 10-acre lake. For pet owners, our Bark Park offers a perfect place for your furry friends to play and explore. \n\nAdditional conveniences include 24-hour emergency maintenance, online rental payments, and an internet café featuring super-fast internet, powered by AT&T. You can also take advantage of package receiving services and our clubhouse, making life in Silver Springs both accessible and enjoyable.\n\nWith easy access to I-35, I-235, and Kellogg, commuting is a breeze. Embrace a lifestyle of comfort, leisure, and connectivity at Silver Springs. Experience upgraded interiors, spacious living areas, and options like walk-in closets and private patios or balconies. \n\nDon’t wait—find your new home today! Browse our available units or schedule a tour to visit our vibrant community. Your peaceful retreat at Silver Springs awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-c1be-7752-99d2-da749c803da4.webp",
  "property_featured_image_media": {
    "alt_text": "Apartment complex exterior with manicured lawns, walkways, and a decorative dry creek bed.",
    "public_id": "019cfb4f-c1be-7752-99d2-da749c803da4",
    "storage_key": "property/6767906449166549/019cfb4f-c1be-7752-99d2-da749c803da4.webp",
    "width": 2560,
    "height": 1920
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum 2 pets per unit; Dogs and cats allowed; No weight limit.",
  "property_pet_policy_description": "Dogs and cats are welcome. Maximum of two pets per unit. No weight limit. Monthly pet rent is $30 per pet. One-time non-refundable fee: $500 for pets up to 80 lb.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://silverspringsapartmentswichita.securecafe.com/onlineleasing/silver-springs-apts/floorplans.aspx",
  "property_resident_portal_url": "https://silverspringsapartmentswichita.securecafe.com/residentservices/silver-springs-apts/userlogin.aspx",
  "property_apply_now_url": "https://silverspringsapartmentswichita.securecafe.com/onlineleasing/silver-springs-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b00-70b3-8657-3dcac4252252.webp",
  "property_primary_logo_media": {
    "alt_text": "Silver Springs Apartment Homes logo",
    "public_id": "019cfb4f-8b00-70b3-8657-3dcac4252252",
    "storage_key": "property/6767906449166549/019cfb4f-8b00-70b3-8657-3dcac4252252.webp",
    "width": 502,
    "height": 263
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb50-15ce-75da-8f78-8f7b2608ebc6.webp",
  "property_icon_media": {
    "alt_text": "Silver Springs Apartment Homes logo.",
    "public_id": "019cfb50-15ce-75da-8f78-8f7b2608ebc6",
    "storage_key": "property/6767906449166549/019cfb50-15ce-75da-8f78-8f7b2608ebc6.webp",
    "width": 500,
    "height": 500
  },
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b00-70b3-8657-3dcac4252252.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Silver Springs Apartment Homes logo",
    "public_id": "019cfb4f-8b00-70b3-8657-3dcac4252252",
    "storage_key": "property/6767906449166549/019cfb4f-8b00-70b3-8657-3dcac4252252.webp",
    "width": 502,
    "height": 263
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb89-1786-7052-be73-2e877cbc0edc.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Silver Springs Apartment Homes logo",
    "public_id": "019cfb89-1786-7052-be73-2e877cbc0edc",
    "storage_key": "property/6767906449166549/019cfb89-1786-7052-be73-2e877cbc0edc.webp",
    "width": 502,
    "height": 263
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#5d3932",
  "property_secondary_color": "#cac4b8",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#d4af37",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "500 - 950",
  "property_sqft_min": "500",
  "property_sqft_max": "950",
  "property_price_range": "784 - 1024",
  "property_price_min": "784",
  "property_price_max": "1024",
  "property_available_units": 13,
  "property_facebook_url": "https://www.facebook.com/silverspringskansas/photos/d41d8cd9/1486644463461205/",
  "property_instagram_url": "https://www.instagram.com/silverspringsapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJteGeH4nguocRmkVmupcNGWg",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/newport-wichita-wichita",
  "property_tiktok_url": "https://www.tiktok.com/@silverspringsapartments",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Silver Springs",
  "property_home_romance_title": "Embrace Cozy Living in Your Perfect Apartment Retreat",
  "property_home_amenities_blurb": "Welcome to Silver Springs, where spacious living meets vibrant community life in the heart of Wichita, KS. Our modern studio, one, and two-bedroom apartments offer upgraded interiors and private balconies, while amenities like a tropical pool, BBQ area, and walking trails beckon outdoor enthusiasts. Your new home awaits!",
  "property_home_floorplans_blurb": "Welcome to Silver Springs in the heart of Wichita, KS, where modern living meets comfort. Choose from cozy studios to spacious two-bedroom apartments, each designed for your lifestyle. Browse our available floor plans and uncover your ideal haven today! Live beautifully, live at Silver Springs.",
  "property_home_gallery_blurb": "At Silver Springs in Wichita, KS, luxury meets lifestyle with thoughtfully designed studio, one, and two-bedroom apartments. Enjoy a sun-soaked sundeck, indoor tropical pool, and scenic walking trails around a 10-acre lake. It's more than a home; it’s where comfort and convenience intertwine. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Silver Springs in vibrant Wichita, KS, where your ideal home awaits in spacious studios, one, or two-bedroom layouts. Immerse yourself in the local scene with close proximity to Friends University, Sedgwick County Zoo, and the Wichita Art Museum. Engage with your community and discover endless opportunities just steps away!",
  "property_home_reviews_blurb": "At Silver Springs in Wichita, KS, our residents rave about the exceptional service and vibrant community. One resident shares, “The staff went above and beyond…making my stay easier.” With prompt maintenance, a pet-friendly atmosphere, and a supportive environment, your perfect home awaits! Join us and feel the difference today!",
  "property_neighborhood_blurb": "At Silver Springs in Wichita, KS, you're surrounded by vibrant attractions. Enjoy learning at the Wichita Public Library or exploring the Wichita Art Museum. Embrace nature at Botanica, The Wichita Gardens, or unwind at Sedgwick County Park. See what's around our community and uncover local gems just outside your door.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Silver Springs in Wichita, KS, find the perfect blend of comfort and convenience. Choose from stylish studio, one, or two-bedroom floor plans. Enjoy our indoor tropical pool, bark park, and scenic walking trails around a tranquil 10-acre lake—ideal for relaxation and recreation. Elevate your lifestyle with us!",
  "property_applynow_blurb": "At Silver Springs in Wichita, KS, your ideal sanctuary awaits, from cozy studios to spacious two-bedroom layouts. Indulge in unique amenities like our indoor tropical pool and serene walking trails around a picturesque 10-acre lake. Experience modern living today—secure your new home and lease online!",
  "property_contactus_blurb": "At Silver Springs in Wichita, KS, our thoughtfully designed studio, one-bedroom, and two-bedroom floor plans cater to your lifestyle. Experience modern living with spacious layouts and vibrant community amenities. Have questions? Our leasing team is ready to help you find your perfect home today—reach out for more information!",
  "property_faqs_blurb": "At Silver Springs in Wichita, KS, we cater to every lifestyle with spacious studio, one-bedroom, and two-bedroom floor plans. Your perfect home awaits! Need more information? Our FAQs page is here to help you uncover all the details about our vibrant community and amenities. Dive in today!",
  "property_floorplans_blurb": "At Silver Springs in Wichita, KS, your ideal home awaits among our thoughtfully designed floor plans. From cozy studios to spacious two-bedroom apartments, each layout harmonizes comfort and style. Browse our available options and envision your future in a space crafted just for you.",
  "property_gallery_blurb": "At Silver Springs in Wichita, KS, your ideal home awaits. Choose from thoughtfully designed studios to spacious two-bedroom layouts, each featuring stylish interiors and generous living spaces. Enjoy resort-style amenities like a tropical indoor pool, gourmet BBQ area, and serene walking trails around a picturesque 10-acre lake. Picture yourself living here!",
  "property_interactivemap_blurb": "At Silver Springs in Wichita, KS, your ideal living space awaits. Choose from stylish studios to spacious two-bedroom apartments, all designed for comfort. Unwind by the tropical pool or enjoy barbecue picnics by the lake. With an interactive community map, finding your perfect home has never been easier!",
  "property_pets_blurb": "At Silver Springs in Wichita, KS, your furry companions are part of the family. With no weight limits and a maximum of two pets per unit, enjoy a home that embraces both comfort and companionship. Revel in city living while your pets explore our vibrant community!",
  "property_referafriend_blurb": "At Silver Springs in Wichita, KS, our diverse floor plans—ranging from cozy studios to spacious two-bedroom apartments—offer the perfect home for everyone. Great friends make great neighbors, so why not share the love? Refer a friend today and build a vibrant community together!",
  "property_residentaccess_blurb": "Welcome to Silver Springs in Wichita, KS, where your perfect home awaits. From stylish studios to spacious two-bedroom layouts, each floor plan is designed for comfort and convenience. Access your resident portal to effortlessly pay rent, request maintenance, and enjoy a seamless living experience. Your sanctuary starts here!",
  "property_reviews_blurb": "At Silver Springs in Wichita, our residents rave about their experiences! With praise for our attentive staff and responsive maintenance, one resident highlights, \"The office staff are very helpful and knowledgeable,” creating a welcoming atmosphere. Join a community where comfort meets care—your perfect home awaits!",
  "property_created_at": "1759851487765",
  "property_scheduletour_blurb": "At Silver Springs in Wichita, KS, our thoughtfully designed floor plans—ranging from cozy studios to spacious two-bedroom apartments—cater to every lifestyle. Schedule a tour today and experience the charm of our vibrant community. Don’t just take our word for it; hear from our residents about their exceptional living experience!",
  "property_thankyou_blurb": "Thank you for reaching out to Silver Springs in vibrant Wichita, KS! We're excited to discuss our captivating studio, one-bedroom, and two-bedroom floor plans tailored for your lifestyle. A member of our team will connect with you soon to guide you toward your ideal home. Stay tuned!",
  "property_virtualtours_blurb": "At Silver Springs in Wichita, KS, experience versatile living with our thoughtfully designed studio, one, and two-bedroom apartments. Each space radiates comfort and style, catering to your unique lifestyle. Ready to envision your future home? Take a virtual tour of our community and apartments for rent today!",
  "property_copyright": "2025 All Rights Reserved. Silver Springs",
  "property_seo_title_home": "Silver Springs |  Apartments in Wichita, KS",
  "property_seo_description_home": "Welcome to Silver Springs in Wichita, KS! Enjoy spacious residences, lush amenities, and nearby walking trails. Your perfect home awaits—join us today!",
  "property_seo_title_floorplans": "Floor Plans | Wichita, KS Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal sanctuary at Silver Springs in Wichita, KS. Choose from studio, one-bedroom, or two-bedroom layouts, and redefine your living experience today!",
  "property_seo_title_amenities": "Amenities | Wichita, KS Apartments for Rent",
  "property_seo_description_amenities": "Discover vibrant living at Silver Springs, Wichita, KS. Enjoy upgraded interiors, an indoor pool, scenic trails, and pet-friendly spaces!",
  "property_seo_title_gallery": "Gallery | Apartments in Wichita, KS",
  "property_seo_description_gallery": "Live your dream at Silver Springs, Wichita! Spacious apartments, resort-style amenities, scenic trails, and a vibrant community await you!",
  "property_seo_title_virtualtours": "Virtual Tours | Silver Springs Apartments",
  "property_seo_description_virtualtours": "Experience Silver Springs in Wichita, KS! Take a virtual tour of our stylish studio, one, and two-bedroom apartments and find your perfect home today!",
  "property_seo_title_interactivemap": "Interactive Map | Silver Springs Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Silver Springs, Wichita! Choose from spacious studios or upgraded two-bedrooms with premium amenities—start your future today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Wichita, KS",
  "property_seo_description_neighborhood": "Uncover Wichita's charm near Silver Springs! Dive into local favorites, vibrant hotspots, and all the joys awaiting just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Silver Springs",
  "property_seo_description_contact": "Connect with Silver Springs in Wichita, KS! Inquire about our stylish floor plans—studio, one and two-bedroom. Your new home awaits; reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Wichita, KS",
  "property_seo_description_faqs": "Find answers to your questions about Silver Springs in Wichita, KS. Discover our amenities, floor plans, and convenient living options. Your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Wichita, KS",
  "property_seo_description_reviews": "Join the Silver Springs family in Wichita, KS! Check out heartfelt resident reviews and see why our cozy community with top-notch amenities feels like home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Wichita, KS",
  "property_seo_description_applynow": "Experience luxury at Silver Springs in Wichita, KS! Choose stylish floor plans, relax by the indoor pool, and enjoy premium amenities. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Silver Springs",
  "property_seo_description_residentaccess": "Welcome to Silver Springs in Wichita, KS! Log in to your resident portal for easy rent payments, maintenance requests, and a seamless living experience.",
  "property_seo_title_referafriend": "Refer A Friend | Silver Springs",
  "property_seo_description_referafriend": "Refer a friend to Silver Springs in Wichita, KS! Share your love for our community and enjoy exclusive rewards!",
  "property_seo_title_scheduletour": "Schedule a Tour | Silver Springs",
  "property_seo_description_scheduletour": "Experience the vibrant charm of Silver Springs in Wichita, KS. Schedule a tour today and envision your new life in our welcoming apartment community!",
  "property_seo_title_privacy": "Privacy Policy | Silver Springs",
  "property_seo_description_privacy": "At Silver Springs, Wichita, your privacy matters. Discover how we secure your info for a safe living experience. View our privacy policy!",
  "property_seo_title_accessibility": "Website Accessibility | Silver Springs",
  "property_seo_description_accessibility": "At Silver Springs in Wichita, KS, we prioritize digital inclusion, ensuring our community is accessible for everyone. Join us in making a difference!",
  "property_seo_title_sitemap": "Sitemap | Silver Springs",
  "property_seo_description_sitemap": "Uncover the layout of Silver Springs in Wichita, KS! Navigate our community and find your ideal home with ease—view our sitemap today!",
  "property_seo_title_thankyou": "Thank You | Silver Springs",
  "property_seo_description_thankyou": "Thank you for reaching out to Silver Springs in Wichita, KS! Our team will be in touch soon to help you find your perfect home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Wichita, KS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865769695",
  "amenities": [
    {
      "id": "ec_0148bd38812f6c5e7639302e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127397124",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d46181a86161813edb0e75e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127397126",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6978e81b7c6e1714a421177c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127397127",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cebad15ad88d85733a73f5d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127397128",
      "title": "Onsite Professional Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d4e227af7d4d264bd8f57d6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127397129",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_542cadf3e075658e418c7f55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127397130",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c0bf4d70bf85fced51aac34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127397131",
      "title": "Indoor Tropical Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_743dfacd123e1779c922eec0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127397132",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e31bd6f53838245bf3c0a72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127397134",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a6e7fe5ef5ea7c13252b54a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127397135",
      "title": "Close to I-35, I-235, and Kellogg",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3425ffc846e8bca0a408b2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127397136",
      "title": "Internet Cafe",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e60556642dc57da971e91b9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127397137",
      "title": "Walking Trails around 10-Acre Lake",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7159c844d668097a2384877",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "128042520",
      "title": "AT&T",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b80c95c42848862f8b18b4d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127397133",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9842a1a7547af8addba790b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127398584",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4a25661ce430b0146dbde69b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127398585",
      "title": "Central Heating & Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4a3013e51619cb98bb3a1372",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127398586",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7ae38da0c604659a1807a5b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127398587",
      "title": "Get Connected To Super-Fast Internet Powered by AT&T",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b5335466b0e0360807b9f17c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127398588",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c142ed52495a537594d3e801",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127398589",
      "title": "Upgraded Interiors*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0ce04fb2073617363fc86b5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127398590",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d300cec8f219cb6ee0154e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127398591",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_64ef0a65d6706a03ccc604b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127398592",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9908e2ac4bfc21d2fcfcc2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127398593",
      "title": "Spacious Living Areas",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9badd0bb21ead8269342ffcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127398594",
      "title": "Washer/Dryer Connections*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa409e9caacda0b06c7b7e91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "yardi",
      "external_id": "127398595",
      "title": "Wood-Burning Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_0952ff6d-b81c-4972-bd36-160a2e8d5444",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-93b9-73d3-aa91-9ac03630e886.webp",
      "image_media": {
        "alt_text": "Dog park area with benches and agility equipment",
        "public_id": "019cfb4f-93b9-73d3-aa91-9ac03630e886",
        "storage_key": "property/6767906449166549/019cfb4f-93b9-73d3-aa91-9ac03630e886.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Explore the spacious dog park, complete with agility equipment and seating for pet owners. Perfect for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Dog park area with benches and agility equipment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/29aea720-2263-425e-a70a-d93ef74bbd96"
    },
    {
      "id": "custom_7870314e-fc07-4186-a794-738e89022474",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-e87d-718e-8d06-0d29b3af5b4d.webp",
      "image_media": {
        "alt_text": "View from a balcony overlooking grassy area and nearby buildings.",
        "public_id": "019cfb4f-e87d-718e-8d06-0d29b3af5b4d",
        "storage_key": "property/6767906449166549/019cfb4f-e87d-718e-8d06-0d29b3af5b4d.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Enjoy the scenic views from the balcony of this apartment, highlighting the spacious outdoor area and nearby residential buildings, perfect for relaxation or entertaining.",
      "link": "",
      "alt_text": "View from a balcony overlooking grassy area and nearby buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/741a66a1-a081-40f5-b255-29d698d4dd9e"
    },
    {
      "id": "custom_37542da2-1fa5-4178-b8db-e77fe4977b16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-e87e-75bd-bb1f-2d77f411bfaf.webp",
      "image_media": {
        "alt_text": "View of a kitchen with wooden cabinets, stove, and refrigerator.",
        "public_id": "019cfb4f-e87e-75bd-bb1f-2d77f411bfaf",
        "storage_key": "property/6767906449166549/019cfb4f-e87e-75bd-bb1f-2d77f411bfaf.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Stylish and functional kitchen featuring modern appliances and plenty of storage, perfect for culinary enthusiasts.",
      "link": "",
      "alt_text": "View of a kitchen with wooden cabinets, stove, and refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/207411ee-ac15-414b-a7de-e931ad724951"
    },
    {
      "id": "custom_dd53b49d-b1f9-4266-8d3b-dbd5011e8954",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-e940-74b2-87e3-e4bd901d84be.webp",
      "image_media": {
        "alt_text": "Cozy dining area with a round table and four chairs in an apartment kitchen.",
        "public_id": "019cfb4f-e940-74b2-87e3-e4bd901d84be",
        "storage_key": "property/6767906449166549/019cfb4f-e940-74b2-87e3-e4bd901d84be.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Explore this inviting dining space featuring a stylish round table, plush seating, and a well-equipped kitchen, perfect for family meals and gatherings.",
      "link": "",
      "alt_text": "Cozy dining area with a round table and four chairs in an apartment kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/fd2b12c5-0ce7-4fee-a325-8e747db9b4c2"
    },
    {
      "id": "custom_c96f638d-cb5e-43e5-ae7b-463d7eab3644",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-e885-702a-8064-f940de65fe2d.webp",
      "image_media": {
        "alt_text": "Cozy living room featuring a beige sofa and decorative table.",
        "public_id": "019cfb4f-e885-702a-8064-f940de65fe2d",
        "storage_key": "property/6767906449166549/019cfb4f-e885-702a-8064-f940de65fe2d.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Explore this inviting apartment living space, complete with plush carpet, stylish furnishings, and natural light from the balcony.",
      "link": "",
      "alt_text": "Cozy living room featuring a beige sofa and decorative table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/0a4e568d-02cc-4b65-a21a-f9daf7a5a6f1"
    },
    {
      "id": "custom_b1e4e6db-74b0-4bd8-94f9-72ef65825de8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-e950-74e8-802e-c003fa6a7b3c.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a bed, lamp, and dresser.",
        "public_id": "019cfb4f-e950-74e8-802e-c003fa6a7b3c",
        "storage_key": "property/6767906449166549/019cfb4f-e950-74e8-802e-c003fa6a7b3c.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Explore this inviting bedroom featuring a comfortable bed, stylish decor, and ample natural light. This space is perfect for relaxation and rest.",
      "link": "",
      "alt_text": "Cozy bedroom with a bed, lamp, and dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/8089f3e7-1c49-4986-b37d-f6e407c8f3eb"
    },
    {
      "id": "custom_20642ba8-4950-4846-911e-19306f4a23c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-e949-725c-afca-4f157c8dbf94.webp",
      "image_media": {
        "alt_text": "Bright kitchen area with wooden cabinets and appliances",
        "public_id": "019cfb4f-e949-725c-afca-4f157c8dbf94",
        "storage_key": "property/6767906449166549/019cfb4f-e949-725c-afca-4f157c8dbf94.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Explore this charming apartment kitchen featuring ample storage, modern appliances, and a welcoming design that makes cooking a delight.",
      "link": "",
      "alt_text": "Bright kitchen area with wooden cabinets and appliances",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/060e3afb-2f34-4fbd-8572-20e676e8181c"
    },
    {
      "id": "custom_f85fde5f-fbe5-4442-91eb-369af5ad0a60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-e948-747b-8cc3-64aa96d4813f.webp",
      "image_media": {
        "alt_text": "Cozy dining area with a round table and colorful artwork on the wall.",
        "public_id": "019cfb4f-e948-747b-8cc3-64aa96d4813f",
        "storage_key": "property/6767906449166549/019cfb4f-e948-747b-8cc3-64aa96d4813f.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Explore this inviting dining space featuring a round table, stylish striped chairs, and bright artwork, perfect for meals and gatherings.",
      "link": "",
      "alt_text": "Cozy dining area with a round table and colorful artwork on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/a5353d71-c36d-43b8-9970-b20a9341a157"
    },
    {
      "id": "custom_148d79b6-0c2a-426d-8f8c-d3356a5cc2e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-e939-75a5-ad9c-b3a97665e5d9.webp",
      "image_media": {
        "alt_text": "Living area of an apartment featuring a small dining table, two chairs, and decorative elements.",
        "public_id": "019cfb4f-e939-75a5-ad9c-b3a97665e5d9",
        "storage_key": "property/6767906449166549/019cfb4f-e939-75a5-ad9c-b3a97665e5d9.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Explore this stylish apartment living space, showcasing modern decor, cozy seating, and a welcoming atmosphere.",
      "link": "",
      "alt_text": "Living area of an apartment featuring a small dining table, two chairs, and decorative elements.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/7156ae74-d8dc-422f-9bc5-e7792f5359b9"
    },
    {
      "id": "custom_cf8e8491-ac82-4c4f-be8e-95e54265dedb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-ea61-743c-afaf-a708c1770eee.webp",
      "image_media": {
        "alt_text": "Cozy living room with a couch and dining table",
        "public_id": "019cfb4f-ea61-743c-afaf-a708c1770eee",
        "storage_key": "property/6767906449166549/019cfb4f-ea61-743c-afaf-a708c1770eee.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Bright and inviting apartment living space featuring modern decor, natural light, and a comfortable seating area, perfect for relaxation or entertaining.",
      "link": "",
      "alt_text": "Cozy living room with a couch and dining table",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/96e26045-0f16-4fc6-9baa-a825acded768"
    },
    {
      "id": "custom_47cfbc21-b1be-4268-8d8d-cf2eff1d1fdc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-ebf1-74f6-9b4c-f51594c03e28.webp",
      "image_media": {
        "alt_text": "View of a bathroom featuring a sink, mirror, shower, and wooden cabinets.",
        "public_id": "019cfb4f-ebf1-74f6-9b4c-f51594c03e28",
        "storage_key": "property/6767906449166549/019cfb4f-ebf1-74f6-9b4c-f51594c03e28.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Explore the comfort of this stylish apartment bathroom, complete with modern fixtures, a spacious vanity, and elegant decor.",
      "link": "",
      "alt_text": "View of a bathroom featuring a sink, mirror, shower, and wooden cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/b230205f-9b68-47d6-9f37-f6063832f7b8"
    },
    {
      "id": "custom_1eb1b95f-886a-44c8-b2a6-2ab515ecfc1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-f596-770c-9e83-85c782035bf4.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a green quilt, wooden furniture, and decorative wall art",
        "public_id": "019cfb4f-f596-770c-9e83-85c782035bf4",
        "storage_key": "property/6767906449166549/019cfb4f-f596-770c-9e83-85c782035bf4.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "This stylish apartment bedroom features a comfortable bed with a green quilt, a modern bedside table, and decorative elements that enhance the living space.",
      "link": "",
      "alt_text": "Cozy bedroom with a green quilt, wooden furniture, and decorative wall art",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/75b2d6a5-2f4a-48e4-9f3f-2789a2be32bd"
    },
    {
      "id": "custom_6e97698c-0809-4840-bbcf-3cbf83531ec7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-f594-7033-af5f-8a71e4228c9a.webp",
      "image_media": {
        "alt_text": "View of a modern kitchen with wooden cabinets, white appliances, and decorative accents.",
        "public_id": "019cfb4f-f594-7033-af5f-8a71e4228c9a",
        "storage_key": "property/6767906449166549/019cfb4f-f594-7033-af5f-8a71e4228c9a.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "This cozy apartment kitchen features wooden cabinetry, a modern white stove, and ample counter space, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "View of a modern kitchen with wooden cabinets, white appliances, and decorative accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/932909c3-2eb4-4bda-bcff-4bb9aae861d6"
    },
    {
      "id": "custom_2b151f75-d557-46bd-a2e4-f194a5bdad56",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-f654-725f-a33f-7536366a1d2f.webp",
      "image_media": {
        "alt_text": "Interior view of a dining area with a round table and modern decor",
        "public_id": "019cfb4f-f654-725f-a33f-7536366a1d2f",
        "storage_key": "property/6767906449166549/019cfb4f-f654-725f-a33f-7536366a1d2f.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "This inviting apartment features a cozy dining area with a contemporary round table, upholstered chairs, and a well-equipped kitchen in the background, highlighted by stylish furnishings and decor.",
      "link": "",
      "alt_text": "Interior view of a dining area with a round table and modern decor",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/87fe1c27-6e19-446b-821e-0378505b0cbf"
    },
    {
      "id": "custom_fbc40919-9671-414c-9c45-9d5cbec60808",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-f5c5-767d-9068-2b2598c544d6.webp",
      "image_media": {
        "alt_text": "Cozy living room with a blue chair and wooden coffee table",
        "public_id": "019cfb4f-f5c5-767d-9068-2b2598c544d6",
        "storage_key": "property/6767906449166549/019cfb4f-f5c5-767d-9068-2b2598c544d6.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Bright and inviting apartment living room featuring modern decor, a comfortable blue armchair, and a stylish wooden coffee table. Large windows allow natural light to fill the space.",
      "link": "",
      "alt_text": "Cozy living room with a blue chair and wooden coffee table",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/90909e3a-b634-4d7a-a433-584f080608f1"
    },
    {
      "id": "custom_b2f86b3c-424a-4278-be72-192dad10fb7f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-f5c6-72ca-be2b-c9e16a60b311.webp",
      "image_media": {
        "alt_text": "Cozy living room featuring a grey sofa, blue accent chair, and a wooden coffee table.",
        "public_id": "019cfb4f-f5c6-72ca-be2b-c9e16a60b311",
        "storage_key": "property/6767906449166549/019cfb4f-f5c6-72ca-be2b-c9e16a60b311.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Stylish and inviting apartment living space designed for comfort, featuring modern furniture and decor, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Cozy living room featuring a grey sofa, blue accent chair, and a wooden coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/e0107a3b-ca7a-41b7-92ea-e24732df28d1"
    },
    {
      "id": "custom_e51bd6f5-4a71-4570-ab3d-8947de212c1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-f696-765b-9ae8-73ba381c89e7.webp",
      "image_media": {
        "alt_text": "Indoor laundry room with vending machine and decorative wall.",
        "public_id": "019cfb4f-f696-765b-9ae8-73ba381c89e7",
        "storage_key": "property/6767906449166549/019cfb4f-f696-765b-9ae8-73ba381c89e7.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "A well-lit laundry room featuring multiple washing machines, a soda vending machine, and decorative elements on the walls, providing a convenient and inviting space for residents.",
      "link": "",
      "alt_text": "Indoor laundry room with vending machine and decorative wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/b3558e75-79a4-4a92-87d8-17c4976444b9"
    },
    {
      "id": "custom_0d276f62-0ac3-443a-b273-12473f90d0de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-f64b-751c-aa02-0334bdddb81e.webp",
      "image_media": {
        "alt_text": "Stylish community lounge with seating and a fireplace",
        "public_id": "019cfb4f-f64b-751c-aa02-0334bdddb81e",
        "storage_key": "property/6767906449166549/019cfb4f-f64b-751c-aa02-0334bdddb81e.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Welcoming community lounge featuring modern decor, comfortable seating, and a cozy fireplace, perfect for social gatherings or relaxed living.",
      "link": "",
      "alt_text": "Stylish community lounge with seating and a fireplace",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/19180fd7-2788-4433-b730-acff75d2db5e"
    },
    {
      "id": "custom_994f0206-60c8-4a68-9b2a-9dde51959ae2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-9333-75ad-a5f7-17257401b375.webp",
      "image_media": {
        "alt_text": "Indoor swimming pool surrounded by lush greenery and seating area.",
        "public_id": "019cfb4f-9333-75ad-a5f7-17257401b375",
        "storage_key": "property/6767906449166549/019cfb4f-9333-75ad-a5f7-17257401b375.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Enjoy the serene indoor swimming pool surrounded by tropical plants and comfortable seating, perfect for relaxation and leisure activities.",
      "link": "",
      "alt_text": "Indoor swimming pool surrounded by lush greenery and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "blob:https://console.multihub.io/fa5b13c5-1115-4230-a6ce-1bbd6726e421"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_0e8c8903-6ba1-4401-9a44-540351cd6abb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "6707 W Kellogg Dr, Wichita, KS 67209, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, prime rib, and appetizers, and the food is consistently good. They highlight the fun, lively atmosphere and the generous portions of rolls and cinnamon butter. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-d1e3-74b4-b97b-2b2199c79172.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-d1e3-74b4-b97b-2b2199c79172",
        "storage_key": "property/6767906449166549/019cfb4f-d1e3-74b4-b97b-2b2199c79172.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/kansas/wichita-west-kellogg?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10790040154516989602&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "37.6720244",
      "poi_longitude": "-97.4200102",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-943-8722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b98c-7530-aae6-0ba1e8a59b8c",
        "storage_key": "property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk_Fxv7nguocRoqYvOlrsvZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_bc2a7cf0-8a2d-4d8d-afcf-639f55324878",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "HomeGrown",
      "poi_type": "Restaurants",
      "poi_address": "645 E Douglas Ave Ste 102, Wichita, KS 67202, USA",
      "poi_short_description": "Open-space eatery with a 'choose kind' motto, serving breakfast items and lunch dishes such as pancakes, waffles and French toast.",
      "poi_long_description": "People say this breakfast restaurant serves delicious biscuits and gravy, French toast, and gluten-free pancakes. They highlight the fresh, locally sourced ingredients and the affordable prices. They also like the friendly staff and fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-a4b9-761f-9ec3-7c0b3c31fdf5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-a4b9-761f-9ec3-7c0b3c31fdf5",
        "storage_key": "property/6767906449166549/019cfb4f-a4b9-761f-9ec3-7c0b3c31fdf5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homegrownkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10686225532294437036&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "homegrown",
      "poi_latitude": "37.6856462",
      "poi_longitude": "-97.3309449",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-247-9509",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b98c-7530-aae6-0ba1e8a59b8c",
        "storage_key": "property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaY-BPffjuocRrJge6oAZTZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_5407cca9-141c-46c3-8d6f-e9d9d3b91bdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Doo-Dah Diner",
      "poi_type": "Restaurants",
      "poi_address": "206 E Kellogg St, Wichita, KS 67202, USA",
      "poi_short_description": "Homey diner serving from-scratch American breakfast & lunch classics, from pancakes to burgers.",
      "poi_long_description": "People say this diner serves delicious banana bread French toast, biscuits and gravy, and monkey bread. They highlight the generous portions, homemade food, and fun, cozy vibe. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-a4c4-75b8-ac83-85858788a584.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-a4c4-75b8-ac83-85858788a584",
        "storage_key": "property/6767906449166549/019cfb4f-a4c4-75b8-ac83-85858788a584.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://doodahdiner.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=12690445211555488726&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "doo-dah-diner",
      "poi_latitude": "37.6796006",
      "poi_longitude": "-97.3364484",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b98c-7530-aae6-0ba1e8a59b8c",
        "storage_key": "property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ13z0ke7juocR1mNS3K6EHbA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_34a1dae0-7d03-4c31-9768-c214ac0836dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "7320 W Taft St, Wichita, KS 67209, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches, waffle fries, and fresh salads. They highlight the friendly staff and quick service, especially for online orders. They also like the clean facility and positive, Christian vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-d1b6-76cb-9e48-304b0bb43584.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-d1b6-76cb-9e48-304b0bb43584",
        "storage_key": "property/6767906449166549/019cfb4f-d1b6-76cb-9e48-304b0bb43584.webp",
        "width": 782,
        "height": 430
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ks/maple-ridge?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3878166640798646112&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "37.6772557",
      "poi_longitude": "-97.4268918",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-729-2697",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b98c-7530-aae6-0ba1e8a59b8c",
        "storage_key": "property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx2yIMLvhuocRYL-SLAME0jU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_8ea76a92-d6c2-4513-b6e9-229e346e30b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Meddys",
      "poi_type": "Restaurants",
      "poi_address": "120 S Washington Ave, Wichita, KS 67202, USA",
      "poi_short_description": "Chain offering Mediterranean staples (shawarma, hummus and falafel) plus wines, beers and cocktails.",
      "poi_long_description": "People say this Mediterranean restaurant serves delicious chicken shawarma, hummus, and falafel. They highlight the generous portions, fair prices, and fresh, flavorful food. They also like the friendly and efficient service, and the warm, inviting atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-d1c8-72da-9284-70dac02784fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-d1c8-72da-9284-70dac02784fd",
        "storage_key": "property/6767906449166549/019cfb4f-d1c8-72da-9284-70dac02784fd.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.meddys.com/contact-us/locations/meddys-downtown/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18251280396411841812&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "meddys",
      "poi_latitude": "37.6854344",
      "poi_longitude": "-97.3261458",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-201-6007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b98c-7530-aae6-0ba1e8a59b8c",
        "storage_key": "property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZpbE6XjuocRFK0tNNKSSf0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_3652df9a-7f78-415a-a023-ca05befb4dbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "8444 W McCormick Ave, Wichita, KS 67209, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of products for home and garden projects. They also highlight the helpful and professional staff, and the well-stocked and clean store.\n\nOther reviews mention the delivery service can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-a4d8-7453-bfb0-d7d1e5c116dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-a4d8-7453-bfb0-d7d1e5c116dd",
        "storage_key": "property/6767906449166549/019cfb4f-a4d8-7453-bfb0-d7d1e5c116dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/West-Wichita/KS/Wichita/67209/2205?emt=MSEN?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13722908378629795426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "37.6738686",
      "poi_longitude": "-97.4402648",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-773-1988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b993-7399-928e-832bd620b47e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b993-7399-928e-832bd620b47e",
        "storage_key": "property/6767906449166549/019cfb4f-b993-7399-928e-832bd620b47e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ0S0uR3euocRYu51mXaQcb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_65705594-3dde-4fc6-90e2-fb0e73fe2d11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "3660 N Maize Rd, Wichita, KS 67205, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "People say this home improvement store offers a wide selection of building supplies, hardware, patio equipment, appliances, paint, lighting, and lawn and garden decor. They also highlight the good prices, easy returns, and helpful staff.\n\nOther reviews mention the store can be difficult to navigate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-a493-72fa-98a8-aa87ab9c8e10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-a493-72fa-98a8-aa87ab9c8e10",
        "storage_key": "property/6767906449166549/019cfb4f-a493-72fa-98a8-aa87ab9c8e10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3276&utm_source=localcard&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=4195684929713849559&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "menards",
      "poi_latitude": "37.7497617",
      "poi_longitude": "-97.4597743",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-729-5851",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b993-7399-928e-832bd620b47e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b993-7399-928e-832bd620b47e",
        "storage_key": "property/6767906449166549/019cfb4f-b993-7399-928e-832bd620b47e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJp792U3Igu4cR18QNwTYROjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_1119d508-4c1f-4816-86b9-182d8c280149",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "333 S Ridge Rd, Wichita, KS 67209, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a great collection of plants. They also highlight the staff is helpful and easy to park.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-a45a-7433-ae36-90f924debba4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-a45a-7433-ae36-90f924debba4",
        "storage_key": "property/6767906449166549/019cfb4f-a45a-7433-ae36-90f924debba4.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/KS-Wichita/0614?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-614-_-na-_-0-_-0&y_source=1_MTE4MzEwNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17050313256936817436&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "37.678859",
      "poi_longitude": "-97.428188",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-773-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b993-7399-928e-832bd620b47e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b993-7399-928e-832bd620b47e",
        "storage_key": "property/6767906449166549/019cfb4f-b993-7399-928e-832bd620b47e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPUZP16LguocRHEPaHJLhnuw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_34a3f95b-164c-4ce2-850b-21ff6b568f70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Thai Binh Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "1530 W 21st St, Wichita, KS 67203, USA",
      "poi_short_description": "Sprawling Asian-style grocery stocking produce and cooking utensils, plus hot foods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-a4b6-739e-9ba5-0bc96bd1d5d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-a4b6-739e-9ba5-0bc96bd1d5d7",
        "storage_key": "property/6767906449166549/019cfb4f-a4b6-739e-9ba5-0bc96bd1d5d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://m.facebook.com/pages/Thai-Binh-Supermarket/165438916815347",
      "poi_directions_map_url": "https://maps.google.com/?cid=12975717193484190098&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "thai-binh-supermarket",
      "poi_latitude": "37.723579",
      "poi_longitude": "-97.355179",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-838-8882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b97c-76bb-b460-5854e94ad99f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b97c-76bb-b460-5854e94ad99f",
        "storage_key": "property/6767906449166549/019cfb4f-b97c-76bb-b460-5854e94ad99f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMceJz4vhuocRksGNBwoCE7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_3678751c-11d4-4ad9-9a6b-0eaa76c99f0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Mi Super Mercado Baratísimo - Seneca - Wichita",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 S Seneca St, Wichita, KS 67217, USA",
      "poi_short_description": "Traditional Mexican grocery store featuring fresh produce, desserts, and groceries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-a48c-73b7-b43a-32b10d9a1707.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-a48c-73b7-b43a-32b10d9a1707",
        "storage_key": "property/6767906449166549/019cfb4f-a48c-73b7-b43a-32b10d9a1707.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "http://www.elriobravokck.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6659820061076927&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mi-super-mercado-baratsimo---seneca---wichita",
      "poi_latitude": "37.6493786",
      "poi_longitude": "-97.3545534",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-269-9119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b97c-76bb-b460-5854e94ad99f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b97c-76bb-b460-5854e94ad99f",
        "storage_key": "property/6767906449166549/019cfb4f-b97c-76bb-b460-5854e94ad99f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFaCidSHnuocRvy0CMRKpFwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_efca37b7-2480-4e4d-864c-db9581c664fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Wichita Public Library - Advanced Learning Library",
      "poi_type": "Education",
      "poi_address": "711 West 2nd St N, Wichita, KS 67203, USA",
      "poi_short_description": "Relaxed public library featuring books and media for kids and adults, plus play spaces, a studio and computers.",
      "poi_long_description": "People say this public library offers a wide selection of books, access to technology, and free classes and live events. They highlight the clean and quiet atmosphere, and the spacious layout with plenty of seating. They also like the helpful staff and the availability of meeting rooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-a80c-752d-a0cb-848dfcf0dc81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-a80c-752d-a0cb-848dfcf0dc81",
        "storage_key": "property/6767906449166549/019cfb4f-a80c-752d-a0cb-848dfcf0dc81.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.wichitalibrary.org/Locations/Pages/advanced-learning-library.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1540515458718365609&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-public-library---advanced-learning-library",
      "poi_latitude": "37.68664890000001",
      "poi_longitude": "-97.3479505",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-261-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b998-750b-a584-4b3ccbbb2dba",
        "storage_key": "property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfx2pGt7juocRqffnz6UCYRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_23ee7219-e823-41e8-827f-bf62f013db1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Friends University",
      "poi_type": "Education",
      "poi_address": "2100 W Univ Ave, Wichita, KS 67213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-a8cc-7701-99d9-3946484a2fee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-a8cc-7701-99d9-3946484a2fee",
        "storage_key": "property/6767906449166549/019cfb4f-a8cc-7701-99d9-3946484a2fee.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "http://www.friends.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15570531106663261673&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "friends-university",
      "poi_latitude": "37.6777089",
      "poi_longitude": "-97.3666702",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-295-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b998-750b-a584-4b3ccbbb2dba",
        "storage_key": "property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV-zLPUThuocR6WXVmIujFdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e8566258-1043-411a-ba84-db666f0c9b17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Newman University",
      "poi_type": "Education",
      "poi_address": "3100 McCormick St, Wichita, KS 67213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-a891-732e-aa28-dba4d0ca033a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-a891-732e-aa28-dba4d0ca033a",
        "storage_key": "property/6767906449166549/019cfb4f-a891-732e-aa28-dba4d0ca033a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.newmanu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8197001651856080544&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "newman-university",
      "poi_latitude": "37.673508",
      "poi_longitude": "-97.377744",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-942-4291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b998-750b-a584-4b3ccbbb2dba",
        "storage_key": "property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjRoRMzHhuocRoP4ropKZwXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_36c6391b-dc19-4bf8-b283-11c29f3731bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Wichita Public Library - Westlink Branch",
      "poi_type": "Education",
      "poi_address": "8515 Bekemeyer St, Wichita, KS 67212, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this public library offers a wide selection of books, movies, TV series, and audiobooks. They highlight the renovated space is beautiful, clean, and comfortable, with plenty of seating and outlets. They also like the friendly, helpful, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-d368-707f-8a7c-18e87b788ee1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-d368-707f-8a7c-18e87b788ee1",
        "storage_key": "property/6767906449166549/019cfb4f-d368-707f-8a7c-18e87b788ee1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.wichitalibrary.org/locations/pages/westlink.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6971528439597698411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-public-library---westlink-branch",
      "poi_latitude": "37.696964",
      "poi_longitude": "-97.4415485",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-337-9456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b998-750b-a584-4b3ccbbb2dba",
        "storage_key": "property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmzQVxiveuocRaw3B1y3Yv2A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_4feef092-1819-4416-a541-5a301dceae25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Sedgwick County Zoo",
      "poi_type": "Entertainment",
      "poi_address": "5555 W Zoo Blvd, Wichita, KS 67212, USA",
      "poi_short_description": "Animals organized by continent, plus educational programs for various age groups.",
      "poi_long_description": "Visitors say this zoo offers a variety of animal experiences, including giraffe feeding, stingray cove, a train ride, and a boat ride, and they praise the well-maintained habitats and friendly staff. They also highlight the family-friendly atmosphere, affordable season passes, and numerous special events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-d3cf-7737-a205-913fd28ffcc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-d3cf-7737-a205-913fd28ffcc9",
        "storage_key": "property/6767906449166549/019cfb4f-d3cf-7737-a205-913fd28ffcc9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://scz.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11432857233417595508&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sedgwick-county-zoo",
      "poi_latitude": "37.717034",
      "poi_longitude": "-97.408561",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-660-9453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDVutukTguocRdGqcdRSrqZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_7c373138-7dd9-4184-9e4e-e39322591ae1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Exploration Place",
      "poi_type": "Entertainment",
      "poi_address": "300 N McLean Blvd, Wichita, KS 67203, USA",
      "poi_short_description": "Exhibits, films, live shows, & hands-on science & discovery programs for kids and adults.",
      "poi_long_description": "People say this science museum offers interactive exhibits, a shark exhibit, and a dome theater. They highlight the educational and entertaining experience, and the fun, hands-on activities for kids and adults. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-a8dd-7058-90b4-0bbeda9864c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-a8dd-7058-90b4-0bbeda9864c3",
        "storage_key": "property/6767906449166549/019cfb4f-a8dd-7058-90b4-0bbeda9864c3.webp",
        "width": 1280,
        "height": 745
      },
      "poi_business_url": "http://www.exploration.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14209503253032261092&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "exploration-place",
      "poi_latitude": "37.6894665",
      "poi_longitude": "-97.3479609",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-660-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b998-750b-a584-4e603ecb327c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b998-750b-a584-4e603ecb327c",
        "storage_key": "property/6767906449166549/019cfb4f-b998-750b-a584-4e603ecb327c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJE7tm5d7juocR5NW-Z-xLMsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_7cd343fe-2243-494c-9fdd-1b49588db061",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "INTRUST Bank Arena",
      "poi_type": "Entertainment",
      "poi_address": "500 E Waterman St, Wichita, KS 67202, USA",
      "poi_short_description": "State-of-the-art entertainment complex hosting sports, concerts, ice shows & conventions.",
      "poi_long_description": "People say this arena offers a variety of events, including hockey games and concerts. They also highlight the clean and well-laid-out venue, comfortable seating, and friendly staff.\n\nOther reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-a8cc-7701-99d9-35409ad190d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-a8cc-7701-99d9-35409ad190d7",
        "storage_key": "property/6767906449166549/019cfb4f-a8cc-7701-99d9-35409ad190d7.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.intrustbankarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2995336029531607261&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intrust-bank-arena",
      "poi_latitude": "37.6832771",
      "poi_longitude": "-97.3320617",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 855-755-7328",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ59VNcOvjuocR3RAptz-SkSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_38a00ad3-4448-4a4b-9065-cbda2fa035de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Wichita Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "1400 Museum Blvd, Wichita, KS 67203, USA",
      "poi_short_description": "Contemporary & historical works from a 7,000-piece permanent collection, & a hands-on area for kids.",
      "poi_long_description": "People say this art museum offers a diverse collection of paintings, photography, and sculptures, including works by local artists and children. They highlight the free admission, the beautiful and colorful entrance, and the rotating exhibits and themes. They also like the family-friendly atmosphere and the fun activities for children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-d56b-70e8-aff0-99177956c835.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-d56b-70e8-aff0-99177956c835",
        "storage_key": "property/6767906449166549/019cfb4f-d56b-70e8-aff0-99177956c835.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://wam.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14953396795402545430&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-art-museum",
      "poi_latitude": "37.6949197",
      "poi_longitude": "-97.3559687",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-268-4921",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b998-750b-a584-4e603ecb327c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b998-750b-a584-4e603ecb327c",
        "storage_key": "property/6767906449166549/019cfb4f-b998-750b-a584-4e603ecb327c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJu0d-QWPhuocRFulurygjhc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_0f19a489-b51b-4cd7-8e72-d1376e46317a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "8545 W Irving St, Wichita, KS 67209, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including trampolines, a zip line, and a ropes course. They also highlight the clean facility and the friendly, helpful staff.\n\nOther reviews mention the height requirements can be unclear.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-a90c-7199-acec-c6b7ba68c21e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-a90c-7199-acec-c6b7ba68c21e",
        "storage_key": "property/6767906449166549/019cfb4f-a90c-7199-acec-c6b7ba68c21e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/kansas-wichita/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=7075506925871037131&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "37.6701433",
      "poi_longitude": "-97.4414467",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-281-7173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJITbj0RzeuocRy_pbug9AMWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_8bde4d3f-9ac8-4374-a4e4-d2bc013c8db7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "WEST YMCA - Greater Wichita YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "6940 Newell St, Wichita, KS 67212, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of classes, including yoga, and has a kid zone. They also highlight the friendly staff and welcoming, homely vibe.\n\nOther reviews mention billing issues can be difficult to resolve.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-d52a-75fb-bdb9-6a0ba04d65b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-d52a-75fb-bdb9-6a0ba04d65b8",
        "storage_key": "property/6767906449166549/019cfb4f-d52a-75fb-bdb9-6a0ba04d65b8.webp",
        "width": 504,
        "height": 378
      },
      "poi_business_url": "https://www.ymcawichita.org/locations/west-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=4228409214553971772&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "west-ymca---greater-wichita-ymca",
      "poi_latitude": "37.6928199",
      "poi_longitude": "-97.4231272",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-942-2271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf-onBo7guocRPFx6DsdTrjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e8dbb62c-2af1-4d69-94a6-bd5caed95be3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Richard A. DeVore SOUTH YMCA - Greater Wichita YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3405 S Meridian Ave Bldg. 1, Wichita, KS 67217, USA",
      "poi_short_description": "Fitness center offering clean facilities, exercise machines, hot tubs, and pools, plus classes.",
      "poi_long_description": "People say this gym offers a variety of equipment and classes. They also highlight the friendly staff and the convenient location.\n\nSome reviews mention the management can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-d559-7369-96e7-8fad81a86d07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-d559-7369-96e7-8fad81a86d07",
        "storage_key": "property/6767906449166549/019cfb4f-d559-7369-96e7-8fad81a86d07.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://ymcawichita.org/locations/richard-devore-south-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=6072621654783976938&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "richard-a-devore-south-ymca---greater-wichita-ymca",
      "poi_latitude": "37.6309425",
      "poi_longitude": "-97.3764392",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-942-5511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5fD39JLmuocR6mW-jDhJRlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_102b4964-6aa2-4cc8-afdd-1c001953c37b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Ken Shannon NORTHWEST Branch - Greater Wichita YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "13838 W 21st St N, Wichita, KS 67235, USA",
      "poi_short_description": "Familiar fitness club offering workout machines, classes (including swimming, yoga and Pilates), a pool and friendly staff, plus a sauna and steam room.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-a933-72bc-b339-7fd0e874a325.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-a933-72bc-b339-7fd0e874a325",
        "storage_key": "property/6767906449166549/019cfb4f-a933-72bc-b339-7fd0e874a325.webp",
        "width": 1280,
        "height": 826
      },
      "poi_business_url": "https://ymcawichita.org/locations/ken-shannon-northwest-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=6593200057211516548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ken-shannon-northwest-branch---greater-wichita-ymca",
      "poi_latitude": "37.7232046",
      "poi_longitude": "-97.5035287",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-260-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH5XYsWvfuocRhHYtD4XAf1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0e4ed6ed-4b67-4cb5-ad46-9d4d7b27a38d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Robert D. Love Downtown YMCA - Greater Wichita YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "402 N Market St, Wichita, KS 67202, USA",
      "poi_short_description": "Nonprofit community center with an indoor track, pools, and courts for racquetball and basketball.",
      "poi_long_description": "People say this gym offers a variety of equipment, a pool, and a track. They also highlight the spacious layout, the separate saunas, and the friendly staff.\n\nOther reviews mention the parking can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-d663-703c-a5c5-24db1ca9a667.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-d663-703c-a5c5-24db1ca9a667",
        "storage_key": "property/6767906449166549/019cfb4f-d663-703c-a5c5-24db1ca9a667.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ymcawichita.org/locations/robert-d-love-downtown-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=2962762509539940888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "robert-d-love-downtown-ymca---greater-wichita-ymca",
      "poi_latitude": "37.6924977",
      "poi_longitude": "-97.33655720000002",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-264-9374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNfK39MPjuocRGBr5Fs7YHSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_777541ff-baac-4490-8497-cda6194633a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Prime Time Barber Shop North Wichita",
      "poi_type": "Health and Wellness",
      "poi_address": "727 W 13th St N, Wichita, KS 67203, USA",
      "poi_short_description": "Barbershop featuring a friendly staff of skilled pros, plus kids' cuts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-a914-756a-834b-a9f93b2e86ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-a914-756a-834b-a9f93b2e86ad",
        "storage_key": "property/6767906449166549/019cfb4f-a914-756a-834b-a9f93b2e86ad.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://getsquire.com/booking/book/prime-time-barbershop-north-wichita",
      "poi_directions_map_url": "https://maps.google.com/?cid=13837457956166592306&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "prime-time-barber-shop-north-wichita",
      "poi_latitude": "37.7076339",
      "poi_longitude": "-97.3476791",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-219-3132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZcaWNiviuocRMme2d7KGCMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_d58f88a1-fdea-4c8d-b7fc-84ea83c222aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Veterinary Emergency & Specialty Hospital of Wichita",
      "poi_type": "Health and Wellness",
      "poi_address": "5618 W 21st St N, Wichita, KS 67205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-d707-74f0-af9d-6abc1b83ef0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-d707-74f0-af9d-6abc1b83ef0e",
        "storage_key": "property/6767906449166549/019cfb4f-d707-74f0-af9d-6abc1b83ef0e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.vetwichita.com/?y_source=1_MTUyMjkzNTAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9151561644725192073&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "veterinary-emergency--specialty-hospital-of-wichita",
      "poi_latitude": "37.7241153",
      "poi_longitude": "-97.4087979",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-262-5321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL_YLl43juocRiUXvLdTgAH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_455157cf-0468-421a-b5bd-c5ed7dc8279c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - West Central",
      "poi_type": "Health and Wellness",
      "poi_address": "854 N Socora St, Wichita, KS 67212, USA",
      "poi_short_description": "Gym and tennis club featuring weight machines, group classes, personal trainers, a pool, saunas and clean locker rooms.",
      "poi_long_description": "People say this gym offers personal training packages and nutrient products. They also highlight the 24-hour access.\n\nOther reviews mention the equipment can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-ac10-72ff-8d0d-168924beab36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-ac10-72ff-8d0d-168924beab36",
        "storage_key": "property/6767906449166549/019cfb4f-ac10-72ff-8d0d-168924beab36.webp",
        "width": 867,
        "height": 488
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/west-central.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=3017945090160134620&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---west-central",
      "poi_latitude": "37.6974426",
      "poi_longitude": "-97.4363575",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-721-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaQpmYNjfuocR3Amh2hHl4Sk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c3752c0a-ebd8-4a63-8946-c250eb1ba6ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2021 N Amidon Ave, Wichita, KS 67203, USA",
      "poi_short_description": "Welcoming facility featuring strength-training equipment, cardio machines and tanning beds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-d8c2-7154-9b64-06fc053502b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-d8c2-7154-9b64-06fc053502b8",
        "storage_key": "property/6767906449166549/019cfb4f-d8c2-7154-9b64-06fc053502b8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/wichita-new-leaf-ks?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=6068367135117192520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "37.72080589999999",
      "poi_longitude": "-97.3649016",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-440-4808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1Ivu5HhuocRSK1Q_8ErN1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ac73a35a-c209-4261-b4fd-aebbb190cc6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Limitless Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "8635 W Central Ave, Wichita, KS 67212, USA",
      "poi_short_description": "Barbershop offering a variety of haircuts, including fades, in a friendly setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-acd3-711e-ac11-6d676a20d225.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-acd3-711e-ac11-6d676a20d225",
        "storage_key": "property/6767906449166549/019cfb4f-acd3-711e-ac11-6d676a20d225.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.limitlessbarbershop.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2406037866442402230&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "limitless-barbershop",
      "poi_latitude": "37.6927246",
      "poi_longitude": "-97.4428108",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-469-8087",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdwzn3G_fuocRtilwGbH2YyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_1acd8038-02ec-460e-8358-5498d77762a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Ascension Via Christi St. Francis",
      "poi_type": "Health and Wellness",
      "poi_address": "929 St Francis, Wichita, KS 67214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-d8ca-75b7-befa-9b84e35c06c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-d8ca-75b7-befa-9b84e35c06c1",
        "storage_key": "property/6767906449166549/019cfb4f-d8ca-75b7-befa-9b84e35c06c1.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/kansas/kswic/wichita-ascension-via-christi-st-francis?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16408748786587986507&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-via-christi-st-francis",
      "poi_latitude": "37.6994424",
      "poi_longitude": "-97.3324685",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 316-268-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b993-7399-928e-84fd2c39008e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b993-7399-928e-84fd2c39008e",
        "storage_key": "property/6767906449166549/019cfb4f-b993-7399-928e-84fd2c39008e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJEQufU8jjuocRS-oyiRWWt-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b70d0a17-2780-45be-8172-fd8cfcfd6aa4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Ascension Via Christi St. Teresa",
      "poi_type": "Health and Wellness",
      "poi_address": "14800 St Teresa St, Wichita, KS 67235, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-d9e7-71f2-a638-9862255e3f82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-d9e7-71f2-a638-9862255e3f82",
        "storage_key": "property/6767906449166549/019cfb4f-d9e7-71f2-a638-9862255e3f82.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/kansas/kswic/wichita-ascension-via-christi-st-teresa?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15586166186925347435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-via-christi-st-teresa",
      "poi_latitude": "37.7257513",
      "poi_longitude": "-97.5132964",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-796-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b993-7399-928e-84fd2c39008e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b993-7399-928e-84fd2c39008e",
        "storage_key": "property/6767906449166549/019cfb4f-b993-7399-928e-84fd2c39008e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJVzCgkXfuocRa9LjZZEvTdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c7e1720e-3896-41c9-8eb4-fcb6e3837468",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Botanica, The Wichita Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "701 Amidon St, Wichita, KS 67203, USA",
      "poi_short_description": "Imaginative, verdant botanical garden with children's areas, a butterfly house, events & more.",
      "poi_long_description": "People say this botanical garden offers a wide variety of plants, a butterfly house, and a children's play area. They highlight the beautiful grounds, the fun and engaging activities for families, and the peaceful and tranquil atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.botanica.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14898597451770473856&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "botanica-the-wichita-gardens",
      "poi_latitude": "37.6964308",
      "poi_longitude": "-97.361781",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-264-0448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeda7xm_huocRgK1RPHJzws4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_48124615-a6a6-40ff-8eb9-3e61f563b305",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Sedgwick County Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6501 W 21st St, Wichita, KS 67205, USA",
      "poi_short_description": "Center for outdoor sports, recreation & fitness, with fishing on 4 lakes, plus shelter rentals.",
      "poi_long_description": "People say this park offers a variety of activities, including playgrounds, walking and biking trails, fishing, and picnic areas. They highlight the spaciousness, beautiful scenery, and family-friendly atmosphere. They also like the well-maintained facilities and clean environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-adbe-70ae-91ca-240e450ce963.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-adbe-70ae-91ca-240e450ce963",
        "storage_key": "property/6767906449166549/019cfb4f-adbe-70ae-91ca-240e450ce963.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sedgwickcounty.org/parks/sedgwick-county-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1140188679586598057&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sedgwick-county-park",
      "poi_latitude": "37.7093827",
      "poi_longitude": "-97.4184872",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-660-1780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b98c-7530-aae6-05d533a997ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b98c-7530-aae6-05d533a997ef",
        "storage_key": "property/6767906449166549/019cfb4f-b98c-7530-aae6-05d533a997ef.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc6auLGjguocRqUyuJ5DD0g8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c1dd6f4b-df37-44d2-a82a-af26bc666d08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "O J Watson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3022 S McLean Blvd, Wichita, KS 67217, USA",
      "poi_short_description": "Popular lakefront park offers fishing, boating, 3 playgrounds, mini golf, kids' rides & concessions.",
      "poi_long_description": "Popular lakefront park offers fishing, boating, 3 playgrounds, mini golf, kids' rides & concessions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-db2c-767a-81ae-d0e2af37cce1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-db2c-767a-81ae-d0e2af37cce1",
        "storage_key": "property/6767906449166549/019cfb4f-db2c-767a-81ae-d0e2af37cce1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wichita.gov/641/OJ-Watson-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17172990704824401430&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "o-j-watson-park",
      "poi_latitude": "37.6394521",
      "poi_longitude": "-97.3425931",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-529-9940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b98c-7530-aae6-05d533a997ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b98c-7530-aae6-05d533a997ef",
        "storage_key": "property/6767906449166549/019cfb4f-b98c-7530-aae6-05d533a997ef.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJH8vteiPkuocRFr4kRA-4Uu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_856106ea-1d98-4fe9-99e8-8ac59c60b42f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Pawnee Prairie Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2625 S Tyler Rd, Wichita, KS 67209, USA",
      "poi_short_description": "Spacious outdoor park with trails for walking, biking & horseback-riding, plus picnic areas.",
      "poi_long_description": "People say this park offers beautiful walking trails, a bike path, and opportunities to see wildlife. They highlight the peaceful and natural escape from the city, and the well-maintained paths suitable for various skill levels. They also like the diverse trails, including a smooth path for beginners and more moderate dirt paths. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-da52-7085-a65e-8c65f33f9e5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-da52-7085-a65e-8c65f33f9e5d",
        "storage_key": "property/6767906449166549/019cfb4f-da52-7085-a65e-8c65f33f9e5d.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Pawnee-Prairie-Park-200",
      "poi_directions_map_url": "https://maps.google.com/?cid=7082970089037678459&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pawnee-prairie-park",
      "poi_latitude": "37.65121",
      "poi_longitude": "-97.4566587",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-268-4361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b98c-7530-aae6-05d533a997ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b98c-7530-aae6-05d533a997ef",
        "storage_key": "property/6767906449166549/019cfb4f-b98c-7530-aae6-05d533a997ef.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99dH-O_duocRe8fOz8TDS2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_467c76f9-9e1c-4aa7-acfc-1201c4c3a9d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Central Riverside Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "720 Nims, Wichita, KS 67203, USA",
      "poi_short_description": "Large park featuring a miniature zoo, playgrounds, a splash pad, walking paths & picnic areas.",
      "poi_long_description": "Visitors say this city park is a great place for picnics, with plenty of trees and space to play Frisbee. They also highlight the playground and barbecue areas, making it a popular spot for families.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Central-Riverside-Park-43",
      "poi_directions_map_url": "https://maps.google.com/?cid=10285259190793395628&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "central-riverside-park",
      "poi_latitude": "37.6970794",
      "poi_longitude": "-97.3466547",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-268-4361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b98c-7530-aae6-05d533a997ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b98c-7530-aae6-05d533a997ef",
        "storage_key": "property/6767906449166549/019cfb4f-b98c-7530-aae6-05d533a997ef.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJicxOUdfjuocRrN0Pir2UvI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_61176d0a-1a67-49c2-a1d5-266b472623b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Wichita Dwight D. Eisenhower National Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2277 Eisenhower Airport Pkwy, Wichita, KS 67209, USA",
      "poi_short_description": "Regional airport offering a host of domestic flights to & from the largest city in Kansas.",
      "poi_long_description": "Visitors say this airport is clean, easy to navigate, and has friendly staff. They also highlight its convenient rental car pickup and drop-off, quick security lines, and efficient check-in process.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.flywichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8128607608438818969&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-dwight-d-eisenhower-national-airport",
      "poi_latitude": "37.6493348",
      "poi_longitude": "-97.4273195",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-946-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b985-7638-b8d7-1d298a75fe89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b985-7638-b8d7-1d298a75fe89",
        "storage_key": "property/6767906449166549/019cfb4f-b985-7638-b8d7-1d298a75fe89.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0QnDVHnuocRmYiIe42dznA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_4e8dd6b7-677d-42d7-8e74-0cbd0b328468",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Textron Aviation C5",
      "poi_type": "Transportation & Transit",
      "poi_address": "C5, Wichita, KS 67209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10430272576288837024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "textron-aviation-c5",
      "poi_latitude": "37.6400806",
      "poi_longitude": "-97.4226631",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b985-7638-b8d7-1d298a75fe89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b985-7638-b8d7-1d298a75fe89",
        "storage_key": "property/6767906449166549/019cfb4f-b985-7638-b8d7-1d298a75fe89.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0ZkKB0jnuocRoM0xbKXFv5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_2ba4b79a-dc31-47e3-be44-c2724aa5aa8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Westport Airport-71K",
      "poi_type": "Transportation & Transit",
      "poi_address": "2558 S Kessler St, Wichita, KS 67217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-db88-776c-8efa-683b8201bd89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-db88-776c-8efa-683b8201bd89",
        "storage_key": "property/6767906449166549/019cfb4f-db88-776c-8efa-683b8201bd89.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4024429820277561674&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westport-airport-71k",
      "poi_latitude": "37.6482314",
      "poi_longitude": "-97.384478",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-943-5510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b985-7638-b8d7-1d298a75fe89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b985-7638-b8d7-1d298a75fe89",
        "storage_key": "property/6767906449166549/019cfb4f-b985-7638-b8d7-1d298a75fe89.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJO4S_s8TmuocRShkiZZml2Tc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_5931d5d9-f1f2-4bf2-a66d-cb6bb901ecbf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "City of Wichita ​City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "455 N Main, Wichita, KS 67202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-dbc6-755c-a3d6-50fed33a56c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-dbc6-755c-a3d6-50fed33a56c1",
        "storage_key": "property/6767906449166549/019cfb4f-dbc6-755c-a3d6-50fed33a56c1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wichita.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4707618743980993027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-wichita-city-hall",
      "poi_latitude": "37.6929601",
      "poi_longitude": "-97.339002",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-942-4482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b985-7638-b8d7-1a8e0776a4d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b985-7638-b8d7-1a8e0776a4d9",
        "storage_key": "property/6767906449166549/019cfb4f-b985-7638-b8d7-1a8e0776a4d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVI-vcTjuocRAyr1PE7SVEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_5666edce-ea26-49ca-ba86-ae6799005882",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Cargill Protein Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "825 E Douglas Ave, Wichita, KS 67202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-dbd8-73f9-8052-72a25974b7e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-dbd8-73f9-8052-72a25974b7e3",
        "storage_key": "property/6767906449166549/019cfb4f-dbd8-73f9-8052-72a25974b7e3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cargill.com/page/cargill-protein-hq",
      "poi_directions_map_url": "https://maps.google.com/?cid=1167281867094812957&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cargill-protein-headquarters",
      "poi_latitude": "37.6853999",
      "poi_longitude": "-97.3279603",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-291-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVWVDpXjuocRHenwcKwEMxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_87378905-eea3-4846-bf59-bc1d704067d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "BG Products, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "740 S Wichita St, Wichita, KS 67213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-dc6c-712e-b7c4-c6e29c1fc562.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-dc6c-712e-b7c4-c6e29c1fc562",
        "storage_key": "property/6767906449166549/019cfb4f-dc6c-712e-b7c4-c6e29c1fc562.webp",
        "width": 1280,
        "height": 826
      },
      "poi_business_url": "https://www.bgprod.com/?utm_source=google&utm_medium=company-profile&utm_content=website-button",
      "poi_directions_map_url": "https://maps.google.com/?cid=3729482907961109433&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bg-products-inc",
      "poi_latitude": "37.67794190000001",
      "poi_longitude": "-97.3403841",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-961-6228",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgxN7feXjuocRuavp9PHIwTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6b368317-86d2-4350-bb61-bffc46aefdde",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Textron Aviation C6",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2655 S Hoover Rd W22, Wichita, KS 67215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b213-761a-b8e9-dde96bbb9f5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b213-761a-b8e9-dde96bbb9f5c",
        "storage_key": "property/6767906449166549/019cfb4f-b213-761a-b8e9-dde96bbb9f5c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.txtav.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3817218495772905269&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "textron-aviation-c6",
      "poi_latitude": "37.6483078",
      "poi_longitude": "-97.4184875",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-517-5755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxff2E9jnuocRNU-YVv97-TQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f3f9b506-b5af-446a-85a4-0285438da93e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Wildcat Power Gen",
      "poi_type": "Major Employers & Offices",
      "poi_address": "930 N Mosley St, Wichita, KS 67214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-dcfe-7188-9c2c-3ec7a59eea1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-dcfe-7188-9c2c-3ec7a59eea1c",
        "storage_key": "property/6767906449166549/019cfb4f-dcfe-7188-9c2c-3ec7a59eea1c.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://wildcatpowergen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11235588861826930689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wildcat-power-gen",
      "poi_latitude": "37.700105",
      "poi_longitude": "-97.3273464",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 620-500-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjwOMbpG3pIcRAZiHh4rU7Js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_2fc400d1-0906-4348-86a2-ddf3d94115b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Bethel College",
      "poi_type": "Education",
      "poi_address": "300 E 27th St, North Newton, KS 67117, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7915-bb43-763a-9743-f2f7f46dbb93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-bb43-763a-9743-f2f7f46dbb93",
        "storage_key": "property/6767906449166549/019d7915-bb43-763a-9743-f2f7f46dbb93.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://bethelks.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14585322687110113431&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bethel-college",
      "poi_latitude": "38.0747258",
      "poi_longitude": "-97.342568",
      "poi_miles_from_property": "30.2 mi",
      "poi_walking_minutes": "10 hours 59 mins",
      "poi_biking_minutes": "2 hours 34 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 316-283-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b998-750b-a584-4b3ccbbb2dba",
        "storage_key": "property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYx-K9VoTu4cRl-ikI7V5aco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_367adba4-28ad-4d75-87c0-183be279a42c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Kensler Elementary School",
      "poi_type": "Education",
      "poi_address": "1030 N Wilbur Ln, Wichita, KS 67212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7915-b90f-747f-bb24-f14ddfe2e1e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-b90f-747f-bb24-f14ddfe2e1e0",
        "storage_key": "property/6767906449166549/019d7915-b90f-747f-bb24-f14ddfe2e1e0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://kensler.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6309509399426161228&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kensler-elementary-school",
      "poi_latitude": "37.7023233",
      "poi_longitude": "-97.4314923",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-973-1350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b998-750b-a584-4b3ccbbb2dba",
        "storage_key": "property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt0OcWYfguocRTNrIm17hj1c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6ed63625-e7cb-41bd-a060-568058109075",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Wilbur Middle School",
      "poi_type": "Education",
      "poi_address": "340 N Tyler Rd, Wichita, KS 67212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7915-b6f5-733e-af95-a7e51e3a9c3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-b6f5-733e-af95-a7e51e3a9c3f",
        "storage_key": "property/6767906449166549/019d7915-b6f5-733e-af95-a7e51e3a9c3f.webp",
        "width": 480,
        "height": 640
      },
      "poi_business_url": "http://wilbur.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15968973275339850066&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wilbur-middle-school",
      "poi_latitude": "37.688307",
      "poi_longitude": "-97.442531",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-973-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b998-750b-a584-4b3ccbbb2dba",
        "storage_key": "property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSQPgYybeuocRUoFWMJYwnd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e17623c2-d1cf-4e32-aa20-e44e1302dd7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Wichita Northwest High School",
      "poi_type": "Education",
      "poi_address": "1220 N Tyler Rd, Wichita, KS 67212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7915-bbe3-765c-af12-ee850fd68463.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-bbe3-765c-af12-ee850fd68463",
        "storage_key": "property/6767906449166549/019d7915-bbe3-765c-af12-ee850fd68463.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://northwest.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11315080650523255213&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-northwest-high-school",
      "poi_latitude": "37.70475589999999",
      "poi_longitude": "-97.440365",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-973-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b998-750b-a584-4b3ccbbb2dba",
        "storage_key": "property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKdEivNXfuocRraFV2-Y9B50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_d687a348-32d2-47b9-ad8c-34e9a21b764d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Wichita State University",
      "poi_type": "Education",
      "poi_address": "1845 Fairmount St, Wichita, KS 67260, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7915-c0a8-739c-ac3b-ec2aeda3cc3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-c0a8-739c-ac3b-ec2aeda3cc3e",
        "storage_key": "property/6767906449166549/019d7915-c0a8-739c-ac3b-ec2aeda3cc3e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wichita.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2193094869087118587&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-state-university",
      "poi_latitude": "37.7190782",
      "poi_longitude": "-97.291526",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 316-978-3456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b998-750b-a584-4b3ccbbb2dba",
        "storage_key": "property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSYDXm-niuocR-2Sr9ilwbx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_326efe4a-0898-4ebf-9ad6-35f769d4375b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "St. Francis of Assisi Catholic School",
      "poi_type": "Education",
      "poi_address": "853 N Socora St, Wichita, KS 67212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.stfranciswichita.com/index.php/school",
      "poi_directions_map_url": "https://maps.google.com/?cid=11799891258123803907&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "st-francis-of-assisi-catholic-school",
      "poi_latitude": "37.6971551",
      "poi_longitude": "-97.4388012",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-722-5171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b998-750b-a584-4b3ccbbb2dba",
        "storage_key": "property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrQ2sPSreuocRA920rJSiwaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_03807bbc-f721-435c-aba6-c47c8a4e05e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Butler Community College Service Center",
      "poi_type": "Education",
      "poi_address": "2626 S Rock Rd #116, Wichita, KS 67210, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.butlercc.edu/info/201029/campus-locations/466/wichita-service-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=2138993657207693331&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "butler-community-college-service-center",
      "poi_latitude": "37.6449504",
      "poi_longitude": "-97.2438717",
      "poi_miles_from_property": "12.8 mi",
      "poi_walking_minutes": "4 hours 47 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 316-323-6060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b998-750b-a584-4b3ccbbb2dba",
        "storage_key": "property/6767906449166549/019cfb4f-b998-750b-a584-4b3ccbbb2dba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzRqjAD77uocRE6Ct-mU7rx0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a85ff09c-73ee-4da6-a99a-3c47fecabd95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "The Sweet Spot Restaurant & Lounge",
      "poi_type": "Restaurants",
      "poi_address": "7703 E Douglas Ave, Wichita, KS 67207, USA",
      "poi_short_description": "Relaxed spot for steak and seafood, plus other American favorites, cocktails and wine.",
      "poi_long_description": "People say this American restaurant serves delicious food, including calamari, pork chops, and salmon. They also highlight the great patio vibe, attentive staff, and the chef's personal touch.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7915-c6bf-71ba-bd5f-a2302eddd7ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-c6bf-71ba-bd5f-a2302eddd7ae",
        "storage_key": "property/6767906449166549/019d7915-c6bf-71ba-bd5f-a2302eddd7ae.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://wichitasweetspot.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6580862354361357816&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-sweet-spot-restaurant-lounge",
      "poi_latitude": "37.6858363",
      "poi_longitude": "-97.2486109",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 316-260-4999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b98c-7530-aae6-0ba1e8a59b8c",
        "storage_key": "property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK7BcokvfuocR-BVzw3HrU1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_854d6da6-a617-46fe-af30-9fcf93fb31d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Sabor Latin Bar & Grille",
      "poi_type": "Restaurants",
      "poi_address": "309 N Mead St, Wichita, KS 67202, USA",
      "poi_short_description": "Contemporary eatery serving up Latin American meat & seafood entrees, plus wine, beer & cocktails.",
      "poi_long_description": "People say this bar and grill offers delicious Latin American dishes, including paella, ceviche, and vegetarian options like arepas and pupusas. They highlight the flavorful food, generous portions, and the variety of options on the menu. They also like the friendly and attentive service, and the chill atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7915-c9f1-7588-bc2f-0871b70c5b34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-c9f1-7588-bc2f-0871b70c5b34",
        "storage_key": "property/6767906449166549/019d7915-c9f1-7588-bc2f-0871b70c5b34.webp",
        "width": 353,
        "height": 421
      },
      "poi_business_url": "https://empireks.com/restaurant/sabor-latin-bar-grille/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10634252004935429153&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sabor-latin-bar-grille",
      "poi_latitude": "37.6901452",
      "poi_longitude": "-97.3297982",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 316-201-4880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7916-1818-724f-bd2d-129b37b3e482.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7916-1818-724f-bd2d-129b37b3e482",
        "storage_key": "property/6767906449166549/019d7916-1818-724f-bd2d-129b37b3e482.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cufdb_juocRIWwpFttzlJM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_23e1f404-647e-4b22-b3ab-7659a317664a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Redrock Canyon Grill - Wichita",
      "poi_type": "Restaurants",
      "poi_address": "1844 N Rock Rd, Wichita, KS 67206, USA",
      "poi_short_description": "Easygoing bistro & bar turning out wood-fired rotisserie chicken & Southwest-inspired dishes.",
      "poi_long_description": "Diners say this American restaurant serves up delicious salmon, meatloaf, and key lime pie, and they praise the cocktails. They also highlight the excellent service and comfortable patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7915-cef1-73a1-bd04-25eab6901e6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-cef1-73a1-bd04-25eab6901e6b",
        "storage_key": "property/6767906449166549/019d7915-cef1-73a1-bd04-25eab6901e6b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.redrockcanyongrill.com/locations/redrock-canyon-grill-wichita/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3489919413144966016&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "redrock-canyon-grill-wichita",
      "poi_latitude": "37.7173429",
      "poi_longitude": "-97.2439943",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 15 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 316-636-1844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b98c-7530-aae6-0ba1e8a59b8c",
        "storage_key": "property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH08HfB_9uocRgNM-QzevbjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_f6675459-f39c-4314-b389-af818338b819",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Bite Me BBQ",
      "poi_type": "Restaurants",
      "poi_address": "132 St Francis, Wichita, KS 67202, USA",
      "poi_short_description": "Family-run BBQ joint serving brisket, pulled pork, ribs & all the trimmings in a down-home setting.",
      "poi_long_description": "People say this barbecue restaurant serves delicious ribs, brisket, and pulled pork. They highlight the generous portions, reasonable prices, and the fun, lively atmosphere. They also like the friendly and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7915-d056-7764-a250-1c4a6e307b9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d056-7764-a250-1c4a6e307b9b",
        "storage_key": "property/6767906449166549/019d7915-d056-7764-a250-1c4a6e307b9b.webp",
        "width": 1280,
        "height": 956
      },
      "poi_business_url": "http://biteme-bbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9339942062092147242&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bite-me-bbq",
      "poi_latitude": "37.6871145",
      "poi_longitude": "-97.3312857",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-729-2904",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b98c-7530-aae6-0ba1e8a59b8c",
        "storage_key": "property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKZaZIMDjuocRKlq7AdIjnoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_ec5c3c5d-f143-4a4b-92cd-ff471cc669d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Kobe Steak House of Japan",
      "poi_type": "Restaurants",
      "poi_address": "8760 W 21st St, Wichita, KS 67205, USA",
      "poi_short_description": "Stylish local Japanese steakhouse chain serving surf 'n' turf grilled tableside & cocktails.",
      "poi_long_description": "People say this Japanese restaurant offers delicious steak, fried rice, and chicken, and the chefs provide entertaining hibachi performances. They highlight the fun and welcoming atmosphere, and the attentive service. They also like the generous portions and the option to take food home.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7915-e471-718f-9cfc-2733aecfe20d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-e471-718f-9cfc-2733aecfe20d",
        "storage_key": "property/6767906449166549/019d7915-e471-718f-9cfc-2733aecfe20d.webp",
        "width": 1280,
        "height": 893
      },
      "poi_business_url": "https://www.kobewichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12227000956179860781&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kobe-steak-house-of-japan",
      "poi_latitude": "37.7236958",
      "poi_longitude": "-97.4440675",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-558-3331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b98c-7530-aae6-0ba1e8a59b8c",
        "storage_key": "property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc_k37JTfuocRLU12lZYIr6k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_d0148a27-05a6-4849-84af-9fd9614c50e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Whiskey Dicks",
      "poi_type": "Restaurants",
      "poi_address": "801 S Seneca St, Wichita, KS 67213, USA",
      "poi_short_description": "Specializing in whiskey & burgers, this sports pub with a patio offers pool, darts & video golf.",
      "poi_long_description": "People say this bar and grill serves great burgers, wings, and a variety of appetizers, and offers a wide selection of whiskeys and cocktails. They highlight the affordable prices, especially during happy hour, and the laid-back, neighborhood bar vibe. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7915-df02-731b-8566-87ff7c4c7541.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-df02-731b-8566-87ff7c4c7541",
        "storage_key": "property/6767906449166549/019d7915-df02-731b-8566-87ff7c4c7541.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.whiskeydicksict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7997562356718223273&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "whiskey-dicks",
      "poi_latitude": "37.6751855",
      "poi_longitude": "-97.3532334",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-201-6209",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7916-1818-724f-bd2d-129b37b3e482.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7916-1818-724f-bd2d-129b37b3e482",
        "storage_key": "property/6767906449166549/019d7916-1818-724f-bd2d-129b37b3e482.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgUA9ilfhuocRqb85LZcM_W4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_7a2f9ab7-749a-4655-af1c-8836a91400c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "El Mexico Cafe",
      "poi_type": "Restaurants",
      "poi_address": "2544 S Seneca St, Wichita, KS 67217, USA",
      "poi_short_description": "Cozy, traditionally decorated Mexican restaurant & lounge serving up classic dishes & margaritas.",
      "poi_long_description": "People say this Mexican restaurant serves flavorful tacos, burritos, and enchiladas, and offers a variety of salsas. They also highlight the generous portions, fresh chips, and the option to refill salsa bowls at the table.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7915-e01e-7628-8da8-fe7344c8f72d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-e01e-7628-8da8-fe7344c8f72d",
        "storage_key": "property/6767906449166549/019d7915-e01e-7628-8da8-fe7344c8f72d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.elmexicowichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11825402409513837159&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "el-mexico-cafe",
      "poi_latitude": "37.6482994",
      "poi_longitude": "-97.3522176",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-558-8220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b98c-7530-aae6-0ba1e8a59b8c",
        "storage_key": "property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkVtbr6DmuocRZ-IeedZEHKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_748e552a-27ea-49b9-8702-7dbeb6e2836d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Newport Grill",
      "poi_type": "Restaurants",
      "poi_address": "1900 N Rock Rd, Wichita, KS 67206, USA",
      "poi_short_description": "Seafood-focused grill with an airy, aquatic-themed room & deck seating overlooking a small lake.",
      "poi_long_description": "People say this asador serves delicious seafood, including fresh oysters, scallops, and sea bass, as well as steak and pasta dishes. They highlight the upscale atmosphere, perfect for special occasions, and the beautiful patio seating with a lakeside view. They also like the attentive service and the well-crafted cocktails and mocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7915-d8cc-736c-94db-dd8250ead0e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d8cc-736c-94db-dd8250ead0e5",
        "storage_key": "property/6767906449166549/019d7915-d8cc-736c-94db-dd8250ead0e5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.newportgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=222403872954958458&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "newport-grill",
      "poi_latitude": "37.7191544",
      "poi_longitude": "-97.2424049",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 316-636-9555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b98c-7530-aae6-0ba1e8a59b8c",
        "storage_key": "property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-8vfSx_9uocResIm5CQjFgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2237e7b3-781c-4a9e-9600-4cbfb8576a39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Ziggy's Pizza East",
      "poi_type": "Restaurants",
      "poi_address": "12115 E 21st St N #105, Wichita, KS 67206, USA",
      "poi_short_description": "Casual, local chain for pizza, toasted sandwiches, wings & salads with craft beer & full bar.",
      "poi_long_description": "People say this pizza restaurant serves excellent pizza, wings, and sandwiches. They highlight the family-friendly vibe and the option to reserve an igloo for private parties. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7915-edda-734c-b180-cbc11632f5bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-edda-734c-b180-cbc11632f5bb",
        "storage_key": "property/6767906449166549/019d7915-edda-734c-b180-cbc11632f5bb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ziggyswichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8303855250327926845&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ziggy-s-pizza-east",
      "poi_latitude": "37.7226386",
      "poi_longitude": "-97.1975523",
      "poi_miles_from_property": "14.1 mi",
      "poi_walking_minutes": "5 hours 13 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 316-779-8181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b98c-7530-aae6-0ba1e8a59b8c",
        "storage_key": "property/6767906449166549/019cfb4f-b98c-7530-aae6-0ba1e8a59b8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmbnUdsn9uocRPfgOvlo4PXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_3389a5c7-183a-456e-89e6-ea4400308ae3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Pavilion Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "2121 N Tyler Rd, Wichita, KS 67212, USA",
      "poi_short_description": "Shopping area featuring Pizza Ranch, plus other local businesses for food, beer and clothing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7915-f4d7-7301-95a4-4798e8a387f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f4d7-7301-95a4-4798e8a387f4",
        "storage_key": "property/6767906449166549/019d7915-f4d7-7301-95a4-4798e8a387f4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2374487620292624961&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pavilion-square",
      "poi_latitude": "37.7221166",
      "poi_longitude": "-97.445541",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b993-7399-928e-832bd620b47e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b993-7399-928e-832bd620b47e",
        "storage_key": "property/6767906449166549/019cfb4f-b993-7399-928e-832bd620b47e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQYdwiN3fuocRQcIa--jf8yA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_363d4631-0b59-4c6f-87b2-870f5a115fb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Northwest Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "8404 W 13th St N, Wichita, KS 67212, USA",
      "poi_short_description": "Strip mall featuring a diverse range of businesses including shops, restaurants and services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7915-f50f-7054-b7fc-23261484e58c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f50f-7054-b7fc-23261484e58c",
        "storage_key": "property/6767906449166549/019d7915-f50f-7054-b7fc-23261484e58c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.occmgmt.com/properties/northwest-centre/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5109942399375061368&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "northwest-shopping-center",
      "poi_latitude": "37.7101789",
      "poi_longitude": "-97.4422811",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-262-3331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGbvh_dbfuocReDF14Ykp6kY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "custom_f6f9ea68-74a8-4412-898b-6a920e9881a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Old Town Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "E 2nd St N, Wichita, KS 67213, USA",
      "poi_short_description": "Entertainment-focused space featuring restaurants and shops, plus a water installation.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7915-fa4e-7442-aff4-5949232d3791.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-fa4e-7442-aff4-5949232d3791",
        "storage_key": "property/6767906449166549/019d7915-fa4e-7442-aff4-5949232d3791.webp",
        "width": 958,
        "height": 1280
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Old-Town-Plaza-40",
      "poi_directions_map_url": "https://maps.google.com/?cid=1159336994733723442&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-town-square",
      "poi_latitude": "37.6901856",
      "poi_longitude": "-97.3291924",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b98c-7530-aae6-05d533a997ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b98c-7530-aae6-05d533a997ef",
        "storage_key": "property/6767906449166549/019cfb4f-b98c-7530-aae6-05d533a997ef.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMcQkaILjuocRMo8SstrKFhA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_56e22f5b-2479-4ff4-9d82-d328e52f1dba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Downtown Wichita",
      "poi_type": "Shopping & Retail",
      "poi_address": "505 E Douglas Ave, Wichita, KS 67202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7915-fc36-77d0-a89c-0896987b135c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-fc36-77d0-a89c-0896987b135c",
        "storage_key": "property/6767906449166549/019d7915-fc36-77d0-a89c-0896987b135c.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.downtownwichita.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14481588482490267160&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "downtown-wichita",
      "poi_latitude": "37.6858842",
      "poi_longitude": "-97.3325092",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-264-6005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBVal8-rjuocRGHY4gv_v-Mg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_944dba45-1daf-46db-b94c-28ffd541effa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "765 N Maize Rd, Wichita, KS 67212, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "People say this supermarket offers a wide variety of reasonably priced produce, delicious prepared foods, and unique items. They highlight the fresh produce, exceptional selection, and affordable prices. They also like the friendly and helpful staff, and the clean, well-organized store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7915-fefe-710e-9e4f-048708d39781.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-fefe-710e-9e4f-048708d39781",
        "storage_key": "property/6767906449166549/019d7915-fefe-710e-9e4f-048708d39781.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ks/wichita/765-n-maize-rd/f301",
      "poi_directions_map_url": "https://maps.google.com/?cid=2076619409595280387&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "37.696619",
      "poi_longitude": "-97.463619",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b97c-76bb-b460-5854e94ad99f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b97c-76bb-b460-5854e94ad99f",
        "storage_key": "property/6767906449166549/019cfb4f-b97c-76bb-b460-5854e94ad99f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0aHHu0veuocRA6ybwlmi0Rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_dc38a8a5-95fa-47ed-9ed1-42de9ff9a6e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "7575 W Maple St, Wichita, KS 67209, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7916-03b2-771f-8298-ffd7258dbdf5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-03b2-771f-8298-ffd7258dbdf5",
        "storage_key": "property/6767906449166549/019d7916-03b2-771f-8298-ffd7258dbdf5.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/wichita-maple/1943",
      "poi_directions_map_url": "https://maps.google.com/?cid=223850493551422223&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "37.6776535",
      "poi_longitude": "-97.4318823",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-729-5348",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b993-7399-928e-832bd620b47e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b993-7399-928e-832bd620b47e",
        "storage_key": "property/6767906449166549/019cfb4f-b993-7399-928e-832bd620b47e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjS_TGaLguocRD6vtftZGGwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_a1917978-0a73-4f22-b7b5-0e17b57d1e50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Kirkland's Home",
      "poi_type": "Shopping & Retail",
      "poi_address": "New Market Square, 2441 N Maize Rd, Wichita, KS 67205, USA",
      "poi_short_description": "Retail chain with a wide assortment of home-decor items & gifts, including pillows, art & bedding.",
      "poi_long_description": "Retail chain with a wide assortment of home-decor items & gifts, including pillows, art & bedding.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7916-055b-70bb-9e88-8a6be8b9589c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-055b-70bb-9e88-8a6be8b9589c",
        "storage_key": "property/6767906449166549/019d7916-055b-70bb-9e88-8a6be8b9589c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kirklands.com/custserv/store.jsp?storeName=New%20Market%20Square",
      "poi_directions_map_url": "https://maps.google.com/?cid=11214056814465920333&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kirkland-s-home",
      "poi_latitude": "37.7295523",
      "poi_longitude": "-97.4662826",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-722-1676",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b993-7399-928e-832bd620b47e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b993-7399-928e-832bd620b47e",
        "storage_key": "property/6767906449166549/019cfb4f-b993-7399-928e-832bd620b47e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJy7Iw4pPfuocRTS1KFUJVoJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_1259623a-edf6-4c7f-a1c6-c1c1369ceb06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Reflection Ridge Golf Course",
      "poi_type": "Entertainment",
      "poi_address": "7700 W Reflection Rd, Wichita, KS 67205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7916-061f-7415-8c51-30ef9136b9db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-061f-7415-8c51-30ef9136b9db",
        "storage_key": "property/6767906449166549/019d7916-061f-7415-8c51-30ef9136b9db.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://reflectionridgegolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17094841704819312163&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "reflection-ridge-golf-course",
      "poi_latitude": "37.727246",
      "poi_longitude": "-97.432121",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-721-4653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7916-1a86-741d-b3c3-0cc36fd74439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7916-1a86-741d-b3c3-0cc36fd74439",
        "storage_key": "property/6767906449166549/019d7916-1a86-741d-b3c3-0cc36fd74439.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJlwb5DAzguocRI8ZJS_UTPe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_7cf40d78-aaa7-4a3f-b442-75d8b740a3c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Great Plains Nature Center",
      "poi_type": "Entertainment",
      "poi_address": "6232 East 29th St N #2200, Wichita, KS 67220, USA",
      "poi_short_description": "Indoor-outdoor facilities designed to educate about the flora & fauna of the Great Plains.",
      "poi_long_description": "People say this nature preserve offers beautiful walking trails, diverse wildlife, and a variety of natural environments. They highlight the peaceful and relaxing atmosphere, and the well-maintained trails with informative signage. They also like the opportunities for birdwatching and the availability of benches for observation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7916-085a-70a8-8fdc-cfe4e6db6c7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-085a-70a8-8fdc-cfe4e6db6c7a",
        "storage_key": "property/6767906449166549/019d7916-085a-70a8-8fdc-cfe4e6db6c7a.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://gpnc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16028016397833359637&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "great-plains-nature-center",
      "poi_latitude": "37.73924",
      "poi_longitude": "-97.263722",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 11 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 316-683-5499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b98c-7530-aae6-05d533a997ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b98c-7530-aae6-05d533a997ef",
        "storage_key": "property/6767906449166549/019cfb4f-b98c-7530-aae6-05d533a997ef.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvcw5n0z9uocRFVH-Zv7zbt4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_637d95af-aca2-4401-8965-2d207ab95fdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Orchard Park Tennis Court",
      "poi_type": "Entertainment",
      "poi_address": "Wichita, KS 67212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7916-0f6d-75e5-b163-6cfda443da1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-0f6d-75e5-b163-6cfda443da1c",
        "storage_key": "property/6767906449166549/019d7916-0f6d-75e5-b163-6cfda443da1c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3681987169685165295&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "orchard-park-tennis-court",
      "poi_latitude": "37.7030511",
      "poi_longitude": "-97.4008013",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b99c-7232-8449-06513df87f86",
        "storage_key": "property/6767906449166549/019cfb4f-b99c-7232-8449-06513df87f86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJszh1DQDhuocR71ShpNILGTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tennis_court"
    },
    {
      "id": "custom_61846570-33d4-460c-995a-eeeddaaaeecb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Regal Warren West",
      "poi_type": "Entertainment",
      "poi_address": "9150 W 21st St, Wichita, KS 67205, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "People say this movie theater offers a variety of films, including IMAX and Screen X options. They also highlight the comfortable seats, clean facilities, and friendly staff.\n\nOther reviews mention the concessions can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7916-0d4e-72e0-b2f3-4881871c5115.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-0d4e-72e0-b2f3-4881871c5115",
        "storage_key": "property/6767906449166549/019d7916-0d4e-72e0-b2f3-4881871c5115.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-warren-west-1443?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3042760775773274275&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "regal-warren-west",
      "poi_latitude": "37.724285",
      "poi_longitude": "-97.44779",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7916-1a84-7259-8b07-3163275692fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7916-1a84-7259-8b07-3163275692fe",
        "storage_key": "property/6767906449166549/019d7916-1a84-7259-8b07-3163275692fe.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJhXKGy-ffuocRo0B16M0OOio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_b6a98988-f0c5-4ec2-a1fd-750af2bc9e2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Museum of World Treasures",
      "poi_type": "Entertainment",
      "poi_address": "835 E 1st St N, Wichita, KS 67202, USA",
      "poi_short_description": "A history-of-the-world museum with an educational focus & hands-on children's activity center.",
      "poi_long_description": "People say this museum offers a wide variety of exhibits, including dinosaurs, mummies, and artifacts from different time periods and cultures. They highlight the impressive collection, the educational experience, and the affordable prices. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019d7916-0cd6-76ab-83bb-be4ad3e329a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-0cd6-76ab-83bb-be4ad3e329a7",
        "storage_key": "property/6767906449166549/019d7916-0cd6-76ab-83bb-be4ad3e329a7.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "http://worldtreasures.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1404316722265454010&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "museum-of-world-treasures",
      "poi_latitude": "37.687089",
      "poi_longitude": "-97.327885",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-b998-750b-a584-4e603ecb327c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-b998-750b-a584-4e603ecb327c",
        "storage_key": "property/6767906449166549/019cfb4f-b998-750b-a584-4e603ecb327c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJdz_xfJXjuocRuvXFVp4ifRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_7b916d93-cb96-498e-8873-e0f8da6b363f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Regal Warren Old Town",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "regal-warren-old-town",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f2fee0b7-f8b1-44c3-a0e4-3bf29241ee8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "Warren Old Town Theatre Grille",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "warren-old-town-theatre-grille",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cad7e325-52e6-4f97-880b-a4e59cbff767",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "poi_name": "West Acres Bowling Center",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "west-acres-bowling-center",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_05a8c63c7d3d1180f1656f60",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a1d5eafee108ce52a863c01f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_d49cb36e15afe38b4cb89612",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a973bc729fe480282f623c43",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6b39e2ffbd6b8d0b3ae4d38a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_cf17ab8b0159248ae7280949",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_630e61c3-4b08-4ad2-b31a-b9e3f6ce07dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "rating": "5.0",
      "name": "Usha KC",
      "text": "I had a wonderful experience during my nearly three-year stay at the apartment. The staff went above and beyond to ensure everything was smooth and hassle-free. From the seamless check-in process to their prompt assistance with any questions I had, they truly made my stay easier. The apartment itself was clean, comfortable, and well-equipped, making it a perfect home away from home. I highly recommend this place to anyone looking for a stress-free stay!",
      "date": "2025-10-01",
      "title": ""
    },
    {
      "id": "custom_8ce63fa9-20b8-40dd-9f6d-1c873276a41c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "rating": "5.0",
      "name": "Dara Nott",
      "text": "I’ve lived in Silver Springs for 4 years now and just moved into my third apartment here. The office ladies are kind and always willing to help. Moving was so easy (besides the actual moving part) because they help you every step of the way.",
      "date": "2025-10-06",
      "title": ""
    },
    {
      "id": "custom_62c6a3b1-17ba-48ce-8b57-683c3d0e725a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "rating": "5.0",
      "name": "Riley Smith",
      "text": "Fellas! Big round of applause for the folks over in building 9 and building 10. I had stayed at this apartment complex in the year of our lord 2024. This is a full review:\n\nMove in:\nAlright move in is gonna be a bit funky. For all of their apartments you can get reserved an apartment instantly if you're able to put up first and last months rent and a small deposit and whatever pet deposits you may have. It get pricey but it's all up front and will be worth it. Just make sure and see if you can tour not the normal showroom apartments but the actual apartment itself. Upper floor and bottom floor studios have different vibes.\n\nThe neighborhood:\nAs a man who would normally partake in the purchases of sodas at all hours of the night inside the laundry facility vending machine I'll say that nothing really happened. I even left my door open for nearly a week straight and nobody broke in. Heck my neighbor was nice enough to shut it whenever the wind would kick it open.\n\nThe issues:\nFunnily enough none of it was major. The building is definitely dated but regarding paint and general quality of life is great. I just wished the stove I had didn't feel like it was from the 1950s. When they say upgrades, they mean upgrades.\n\nGet a 2nd floor apartment if you can. Moving furniture will be a pain but you will love yourself if you have a pet. All stairs are indoor, too!\n\nMaintenance:\nGotta say the maintenance team they got is a real crack shot crew. Had my cabinet door fall off a few times but they showed up to fix it ASAP. The maintenance guys seem to love their job and helping out residents.\n\nMoving out:\nThis is where I thought I would get in deep trouble but surprisingly if you're up front about recent issues, ask for resolutions to certain problems and at least try to fix it then the office is super willing to work with you. Overall, the fees I got were definitely justified. Just make sure to do that final walk through with staff before fully moving.\n\nAll in all its a super great place to live for the buildings i was near.",
      "date": "2025-05-02",
      "title": ""
    },
    {
      "id": "custom_f6665c87-f76e-460e-8254-ca7dcb9615bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "rating": "5.0",
      "name": "Sotto Voce",
      "text": "Excellent office staff and maintenance.The office staff are very helpful and knowledgeable. They appear to be LGBTQIA+ friendly from what I have observed. They also allow pets, which makes my apartment a true home.  I have had every maintenance issue addressed within 24 hours, even if it was non-urgent.  When there were safety issues, these were addressed immediately and actions taken swiftly to ensure the safety of those of us who live here. Rent is a little high for me, but it’s comparable with the current rental market.",
      "date": "2025-04-19",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_e9c4c535-62b1-47be-8e43-013a53e1f277",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb50-0956-769b-895a-b48834009e54.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of community lounge area with bar seating and lounge furniture",
        "public_id": "019cfb50-0956-769b-895a-b48834009e54",
        "storage_key": "property/6767906449166549/019cfb50-0956-769b-895a-b48834009e54.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Silver Springs Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=5f44d2f6601bdb1ec052f17f"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a03b5-5395-7176-9491-8771e6badeee",
      "lead_source": "LANDING_PAGE",
      "name": "case-silver-springs-lp",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549"
    },
    {
      "lead_collector_id": "019cf79d-4a04-702d-a227-92fc61800a37",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "silver-springs-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "generator",
      "page_item_url": "indoor-pool-apartments-wichita",
      "search_query": "apartments with indoor pool in Wichita KS",
      "category": "Amenity",
      "h1_title": "Apartments with Indoor Pool in Wichita KS",
      "h2_subtitle": "Discover stylish apartments with an indoor pool in Wichita. Silver Springs offers modern living with great amenities.",
      "page_copy": "Experience the ultimate in leisurely living at Silver Springs, your premier choice for apartments with an indoor pool in Wichita, KS. Our indoor tropical pool provides year-round enjoyment and relaxation. Imagine a refreshing swim no matter the weather outside, right in the heart of our community.\n\nAt Silver Springs, every detail caters to your comfort and convenience. Choose from spacious studio, one, or two-bedroom floor plans designed for modern living. Enjoy additional amenities such as a BBQ area, scenic walking trails, and the comfort of central heating and air. Contact us now to explore availability and book a tour of your next home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
      "featured_image_media": {
        "alt_text": "Silver Springs Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb4f-8b01-72a6-9dc5-cdcd6260684b",
        "storage_key": "property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
        "width": 500,
        "height": 571
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wichita KS Apartments with Indoor Pool",
      "seo_description": "Find modern Wichita KS apartments with indoor pool amenities at Silver Springs. Comfortable living with great features awaits you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "generator",
      "page_item_url": "dog-park-apartments-67212",
      "search_query": "dog park apartments Wichita 67212",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Wichita 67212",
      "h2_subtitle": "Explore dog-friendly apartments in Wichita's 67212 area. Silver Springs offers spacious living and pet-focused amenities.",
      "page_copy": "For pet lovers seeking dog park apartments in Wichita’s 67212 zip code, Silver Springs is the perfect choice. Our community is ideal for you and your four-legged friends, offering ample walking trails and the nearby convenience of local dog parks. Here, every day is a new adventure with your pet.\n\nAt Silver Springs, comfort and convenience are at the forefront. Choose from studio, one, or two-bedroom floor plans, each tailored for modern living. Discover amenities like a private patio or balcony, central heating and air, and super-fast internet powered by AT&T. Experience a community that truly welcomes you and your furry companion. Schedule a visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
      "featured_image_media": {
        "alt_text": "Silver Springs Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb4f-8b01-72a6-9dc5-cdcd6260684b",
        "storage_key": "property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
        "width": 500,
        "height": 571
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wichita 67212 Dog Park Apartments",
      "seo_description": "Find perfect dog park apartments in Wichita 67212 at Silver Springs. Spacious, pet-friendly living with great amenities awaits you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "generator",
      "page_item_url": "spacious-apartments-bbq-area-sedgwick",
      "search_query": "spacious apartments with BBQ area Sedgwick County",
      "category": "Amenity",
      "h1_title": "Spacious Apartments with BBQ Area",
      "h2_subtitle": "Experience spacious apartment living with a BBQ area in Sedgwick County. Silver Springs offers great amenities and comfort.",
      "page_copy": "Enjoy a blend of comfort and recreation at Silver Springs, where spacious apartments meet social amenities such as a BBQ area in Sedgwick County. Our community is ideal for those who love hosting gatherings and enjoying outdoor meals with family and friends. The BBQ area provides a perfect spot for creating memorable moments right outside your doorstep.\n\nSilver Springs offers a variety of floor plans, including studios, one, and two-bedroom options, each designed for modern living. Residents can also enjoy an indoor tropical pool, scenic walking trails, and private patios or balconies. Elevate your lifestyle in a community that promotes both convenience and enjoyment. Schedule a tour today to see all that we offer!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
      "featured_image_media": {
        "alt_text": "Silver Springs Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb4f-8b01-72a6-9dc5-cdcd6260684b",
        "storage_key": "property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
        "width": 500,
        "height": 571
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sedgwick County Spacious Apartments with BBQ",
      "seo_description": "Discover Sedgwick County spacious apartments with a BBQ area at Silver Springs. Enjoy great amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "generator",
      "page_item_url": "wichita-apartments-walking-trails",
      "search_query": "Wichita KS apartments with walking trails",
      "category": "Amenity",
      "h1_title": "Wichita KS Apartments with Walking Trails",
      "h2_subtitle": "Discover Wichita KS apartments featuring scenic walking trails. Silver Springs offers a perfect blend of relaxation and activity.",
      "page_copy": "Embrace an active lifestyle at Silver Springs, where Wichita KS apartments offer beautiful walking trails right at your doorstep. These scenic paths provide the perfect setting for morning jogs, peaceful strolls, or quality time with pets. Experience the blend of nature and convenience right outside your residence.\n\nIn addition to the walking trails, Silver Springs provides a variety of comfortable studio, one, and two-bedroom floor plans. Enjoy modern amenities like an indoor tropical pool, private patios or balconies, and super-fast internet powered by AT&T. At Silver Springs, every day is an opportunity to enjoy outdoor living while staying connected and comfortable. Visit us to explore more!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
      "featured_image_media": {
        "alt_text": "Silver Springs Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb4f-8b01-72a6-9dc5-cdcd6260684b",
        "storage_key": "property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
        "width": 500,
        "height": 571
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wichita KS Apartments with Walking Trails",
      "seo_description": "Find Wichita KS apartments with scenic walking trails at Silver Springs. Enjoy nature and convenience with modern living and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "generator",
      "page_item_url": "air-conditioned-upgraded-interiors-wichita",
      "search_query": "air conditioned apartments with upgraded interiors Wichita",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Wichita",
      "h2_subtitle": "Experience air-conditioned comfort and upgraded interiors in Wichita. Silver Springs enhances your living with modern amenities.",
      "page_copy": "Discover the comfort of air-conditioned apartments with upgraded interiors at Silver Springs in Wichita. Our community is designed to keep you cool and comfortable during the warm Kansas summers, while also offering stylish interiors that elevate your daily living experience.\n\nSilver Springs features a selection of spacious studio, one, and two-bedroom floor plans, each equipped with central heating and air. Enjoy modern amenities like private patios or balconies, an indoor tropical pool, and an active community with scenic walking trails. Experience enhanced living in a community that combines practicality with elegant design. Visit us today to see all that Silver Springs has to offer!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
      "featured_image_media": {
        "alt_text": "Silver Springs Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb4f-8b01-72a6-9dc5-cdcd6260684b",
        "storage_key": "property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
        "width": 500,
        "height": 571
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Wichita",
      "seo_description": "Explore air-conditioned apartments with upgraded interiors in Wichita at Silver Springs. Enjoy stylish living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "generator",
      "page_item_url": "studio-apartments-wichita-silver-springs",
      "search_query": "studio apartments in Wichita",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Wichita",
      "h2_subtitle": "Explore cozy studio apartments in Wichita at Silver Springs. Discover modern amenities and convenient living options today.",
      "page_copy": "Silver Springs offers comfortable studio apartments in Wichita, perfect for those seeking a blend of style and convenience. Our studio apartments are thoughtfully designed to maximize living space while providing a cozy atmosphere.\n\nResidents at Silver Springs enjoy access to an indoor tropical pool, scenic walking trails, and super-fast internet powered by AT&T. Each studio apartment includes a private patio or balcony, ideal for relaxing evenings. Embrace a community lifestyle with modern amenities that complement your daily routine. Schedule a tour of Silver Springs and find the perfect studio apartment to call home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
      "featured_image_media": {
        "alt_text": "Silver Springs Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb4f-8b01-72a6-9dc5-cdcd6260684b",
        "storage_key": "property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
        "width": 500,
        "height": 571
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Wichita",
      "seo_description": "Find your ideal studio apartment in Wichita at Silver Springs. Enjoy modern amenities and convenient living in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-sedgwick-county",
      "search_query": "1 bedroom apartments Sedgwick County",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Sedgwick County",
      "h2_subtitle": "Discover the comfort of 1 bedroom apartments in Sedgwick County. Silver Springs offers modern living spaces and amenities.",
      "page_copy": "Looking for a comfortable 1 bedroom apartment in Sedgwick County? Silver Springs in Wichita offers spacious and well-designed floor plans that cater to your needs. Our 1 bedroom apartments are perfect for individuals or couples seeking a cozy yet modern living environment.\n\nEnjoy life-enhancing amenities such as a wood-burning fireplace, a private patio or balcony, and central heating & air conditioning. The community features an indoor tropical pool, scenic walking trails, and a sundeck where you can relax and enjoy the beautiful Kansas weather. Move into Silver Springs and experience the perfect blend of comfort and convenience in Sedgwick County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
      "featured_image_media": {
        "alt_text": "Silver Springs Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb4f-8b01-72a6-9dc5-cdcd6260684b",
        "storage_key": "property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
        "width": 500,
        "height": 571
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Sedgwick County",
      "seo_description": "Explore 1 bedroom apartments at Silver Springs in Sedgwick County. Enjoy modern living spaces with great amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-67212",
      "search_query": "2 bedroom apartments near 67212",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near 67212",
      "h2_subtitle": "Discover spacious 2 bedroom apartments near 67212. Silver Springs offers modern amenities and comfortable living.",
      "page_copy": "Silver Springs features spacious 2 bedroom apartments near the 67212 area, ideal for small families or roommates looking for comfortable living spaces. Each apartment is designed to provide a balance between modern style and daily convenience.\n\nOur community offers a wide range of amenities, including a wood-burning fireplace and a private patio or balcony, perfect for unwinding after a long day. Residents also enjoy access to an indoor tropical pool, BBQ area, and high-speed internet powered by AT&T. Explore the walking trails around the community and embrace a lifestyle of relaxation and leisure at Silver Springs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
      "featured_image_media": {
        "alt_text": "Silver Springs Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb4f-8b01-72a6-9dc5-cdcd6260684b",
        "storage_key": "property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
        "width": 500,
        "height": 571
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near 67212",
      "seo_description": "Find spacious 2 bedroom apartments near 67212 at Silver Springs. Enjoy modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "generator",
      "page_item_url": "apartments-near-friends-university-wichita",
      "search_query": "apartments near Friends University Wichita",
      "category": "School",
      "h1_title": "Apartments Near Friends University",
      "h2_subtitle": "Discover convenient apartments near Friends University in Wichita. Silver Springs offers modern living with exciting amenities.",
      "page_copy": "Located just a short drive from Friends University, Silver Springs provides ideal apartment living for students and faculty alike. Our community in Wichita offers a perfect mix of convenience and comfort with a variety of floor plans including studio, one, and two-bedroom options.\n\nEnjoy living in a vibrant community with access to amenities like a wood-burning fireplace, private patio or balcony, and super-fast internet powered by AT&T. Residents can also take advantage of the tropical indoor pool and scenic walking trails. Whether you’re studying or teaching at Friends University, Silver Springs is a top choice for a welcoming and modern living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
      "featured_image_media": {
        "alt_text": "Silver Springs Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb4f-8b01-72a6-9dc5-cdcd6260684b",
        "storage_key": "property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
        "width": 500,
        "height": 571
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Friends University Wichita",
      "seo_description": "Find perfect apartments near Friends University at Silver Springs. Enjoy modern amenities and convenient access in Wichita.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "generator",
      "page_item_url": "apartments-close-to-newman-university-sedgwick-county",
      "search_query": "apartments close to Newman University Sedgwick County",
      "category": "School",
      "h1_title": "Apartments Close to Newman University",
      "h2_subtitle": "Find modern apartments close to Newman University in Sedgwick County. Silver Springs offers comfort and convenience.",
      "page_copy": "Silver Springs, situated in Sedgwick County, provides the ideal living environment just minutes away from Newman University. Whether you're a student or staff member, our community offers a range of apartment options that cater to your lifestyle needs, from studios to two-bedroom layouts.\n\nEnjoy the many amenities that come with living at Silver Springs, including a wood-burning fireplace, private patios, and access to a sun deck. With super-fast internet provided by AT&T, staying connected is easier than ever. Dive into our indoor tropical pool after a long day or enjoy a barbecue at our community BBQ area. Experience the convenience and comfort of living close to Newman University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
      "featured_image_media": {
        "alt_text": "Silver Springs Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb4f-8b01-72a6-9dc5-cdcd6260684b",
        "storage_key": "property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
        "width": 500,
        "height": 571
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Newman University",
      "seo_description": "Explore apartments close to Newman University at Silver Springs. Enjoy a convenient and comfortable lifestyle in Sedgwick County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "generator",
      "page_item_url": "apartments-near-ascension-via-christi-st-francis-wichita",
      "search_query": "apartments near ascension via christi st francis wichita",
      "category": "Hospital",
      "h1_title": "Apartments Near Ascension Via Christi St. Francis",
      "h2_subtitle": "Explore comfortable apartments near Ascension Via Christi St. Francis in Wichita. Silver Springs offers prime living options.",
      "page_copy": "Located conveniently close to Ascension Via Christi St. Francis in Wichita, Silver Springs provides residents with easy access to healthcare facilities and more. Our community offers a variety of living spaces, including studio, one, and two-bedroom apartments, designed for modern comfort.\n\nResidents at Silver Springs enjoy amenities such as a private patio or balcony and a wood-burning fireplace. Our community features an indoor tropical pool, scenic walking trails, and high-speed internet powered by AT&T, ensuring you stay connected and entertained. Whether you work at Ascension Via Christi St. Francis or simply want to be nearby, Silver Springs is a welcoming choice.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
      "featured_image_media": {
        "alt_text": "Silver Springs Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb4f-8b01-72a6-9dc5-cdcd6260684b",
        "storage_key": "property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
        "width": 500,
        "height": 571
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ascension Via Christi St. Francis",
      "seo_description": "Discover apartments near Ascension Via Christi St. Francis in Wichita at Silver Springs. Enjoy comfort and convenience in our vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "generator",
      "page_item_url": "apartments-close-to-ascension-via-christi-st-teresa-sedgwick-county",
      "search_query": "apartments close to ascension via christi st teresa sedgwick county",
      "category": "Hospital",
      "h1_title": "Apartments Close to Ascension Via Christi St. Teresa",
      "h2_subtitle": "Find comfortable apartments close to Ascension Via Christi St. Teresa in Sedgwick County. Experience the convenience of Silver Springs.",
      "page_copy": "Nestled in Sedgwick County, Silver Springs offers excellent living options just a short drive from Ascension Via Christi St. Teresa. Our range of floor plans, including studios and spacious one or two-bedroom apartments, caters to diverse lifestyle needs.\n\nEnjoy the comfort of having a private patio or balcony and the warmth of a wood-burning fireplace at Silver Springs. Our community features include a sundeck, tropical indoor pool, and scenic walking trails—paths that offer a peaceful retreat after a day of work. With super-fast internet powered by AT&T, staying online is no problem. Discover modern comfort and convenience at Silver Springs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
      "featured_image_media": {
        "alt_text": "Silver Springs Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb4f-8b01-72a6-9dc5-cdcd6260684b",
        "storage_key": "property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
        "width": 500,
        "height": 571
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Ascension Via Christi St. Teresa",
      "seo_description": "Explore apartments close to Ascension Via Christi St. Teresa at Silver Springs. Offering comfort and convenience in Sedgwick County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "generator",
      "page_item_url": "apartments-near-botanica-the-wichita-gardens",
      "search_query": "apartments near Botanica The Wichita Gardens",
      "category": "Park",
      "h1_title": "Apartments Near Botanica, The Wichita Gardens",
      "h2_subtitle": "Explore apartments near Botanica, The Wichita Gardens. Silver Springs offers modern living with natural beauty nearby.",
      "page_copy": "Located within easy reach of Botanica, The Wichita Gardens, Silver Springs in Wichita, KS offers a blend of convenient urban living and serene natural surroundings. Everything you need, from studios to spacious two-bedroom apartments, is right here.\n\nAt Silver Springs, residents can enjoy the refreshing atmosphere created by amenities like an indoor tropical pool, scenic walking trails, and cozy wood-burning fireplaces. The beautiful surroundings of Botanica and our amenities like private patios or balconies enhance your living experience. Enjoy high-speed internet with AT&T, making every day productive and connected. Discover the unique charm and comfort that Silver Springs provides while being near the glorious Botanica Gardens.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
      "featured_image_media": {
        "alt_text": "Silver Springs Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb4f-8b01-72a6-9dc5-cdcd6260684b",
        "storage_key": "property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
        "width": 500,
        "height": 571
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Botanica, The Wichita Gardens",
      "seo_description": "Discover Silver Springs, offering modern living near Botanica, The Wichita Gardens in Wichita. Enjoy comfort and convenience with nature close by.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "generator",
      "page_item_url": "rentals-close-to-sedgwick-county-park-wichita",
      "search_query": "rentals close to Sedgwick County Park Wichita",
      "category": "Park",
      "h1_title": "Rentals Close to Sedgwick County Park",
      "h2_subtitle": "Discover rentals close to Sedgwick County Park in Wichita. Enjoy the perfect blend of comfort and nature at Silver Springs.",
      "page_copy": "Silver Springs offers the ideal location for those seeking rentals close to Sedgwick County Park in Wichita. Experience the beauty of nature paired with the conveniences of modern living in our studio, one, and two-bedroom apartments.\n\nEnjoy our community's amenities, including an inviting indoor tropical pool and scenic walking trails that mirror the natural allure of nearby Sedgwick County Park. With features like a private patio or balcony and AT&T's super-fast internet, Silver Springs ensures you're both comfortable and connected. Choose Silver Springs for a community that provides easy access to both urban and natural attractions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
      "featured_image_media": {
        "alt_text": "Silver Springs Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb4f-8b01-72a6-9dc5-cdcd6260684b",
        "storage_key": "property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
        "width": 500,
        "height": 571
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Sedgwick County Park",
      "seo_description": "Explore Silver Springs rentals near Sedgwick County Park in Wichita. Enjoy modern comfort and scenic surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "generator",
      "page_item_url": "apartments-by-o-j-watson-park-67212",
      "search_query": "apartments by O J Watson Park 67212",
      "category": "Park",
      "h1_title": "Apartments by O J Watson Park",
      "h2_subtitle": "Discover your new home at Silver Springs, conveniently located near O J Watson Park in the 67212 area.",
      "page_copy": "If you’re searching for apartments by O J Watson Park in the 67212 zip code, Silver Springs offers the perfect retreat. With easy access to one of Wichita’s beloved parks, our community provides an exceptional living experience in both location and style.\n\nChoose from our selection of studio, one, or two-bedroom floor plans, all designed with modern touches. Enjoy features like a private patio or balcony and a cozy wood-burning fireplace. Community amenities such as a tropical indoor pool and scenic walking trails complement your outdoor lifestyle, while AT&T's super-fast internet keeps you connected. Experience what it means to live close to nature without sacrificing convenience at Silver Springs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
      "featured_image_media": {
        "alt_text": "Silver Springs Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb4f-8b01-72a6-9dc5-cdcd6260684b",
        "storage_key": "property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
        "width": 500,
        "height": 571
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by O J Watson Park",
      "seo_description": "Find your new home at Silver Springs near O J Watson Park in Wichita's 67212 area. Enjoy modern living with nature nearby.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "generator",
      "page_item_url": "apartment-living-near-central-riverside-park-wichita",
      "search_query": "apartment living near Central Riverside Park Wichita",
      "category": "Park",
      "h1_title": "Apartment Living Near Central Riverside Park",
      "h2_subtitle": "Enjoy apartment living near Central Riverside Park in Wichita. Silver Springs offers the perfect blend of comfort and outdoor adventure.",
      "page_copy": "Experience the best of apartment living near Central Riverside Park in Wichita at Silver Springs. Our community combines modern amenities with perfect proximity to lush green spaces, ensuring you have both convenience and nature at your doorstep.\n\nSilver Springs offers a range of spacious studios and one or two-bedroom apartments, designed with modern living in mind. Relax on your private patio or balcony, or enjoy the cozy ambiance of a wood-burning fireplace. Residents benefit from community features like an indoor tropical pool and an expansive sundeck, ideal for both relaxation and socializing. With super-fast internet from AT&T, your living experience is both comfortable and connected. Discover all that Silver Springs has to offer just a short distance from Central Riverside Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
      "featured_image_media": {
        "alt_text": "Silver Springs Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb4f-8b01-72a6-9dc5-cdcd6260684b",
        "storage_key": "property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
        "width": 500,
        "height": 571
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Living Near Central Riverside Park",
      "seo_description": "Explore Silver Springs for stylish apartment living near Central Riverside Park in Wichita. Enjoy modern amenities and easy access to green spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166549",
      "source": "generator",
      "page_item_url": "find-apartments-near-pawnee-prairie-park-sedgwick-county",
      "search_query": "find apartments near Pawnee Prairie Park Sedgwick County",
      "category": "Park",
      "h1_title": "Find Apartments Near Pawnee Prairie Park",
      "h2_subtitle": "Looking for apartments near Pawnee Prairie Park in Sedgwick County? Discover Silver Springs and enjoy both nature and modern amenities.",
      "page_copy": "For those searching to find apartments near Pawnee Prairie Park in Sedgwick County, Silver Springs offers a perfect home base. Embrace the tranquility of natural surroundings while enjoying the perks of modern apartment living in Wichita.\n\nSilver Springs provides spacious living options with studio, one, and two-bedroom floor plans, each featuring a private patio or balcony, and select units with a wood-burning fireplace. Our community amenities elevate your lifestyle with an indoor tropical pool and a BBQ area ideal for entertaining. Keeping you connected, super-fast internet powered by AT&T is readily available. Choose Silver Springs for an unparalleled living experience just a stone's throw from Pawnee Prairie Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
      "featured_image_media": {
        "alt_text": "Silver Springs Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb4f-8b01-72a6-9dc5-cdcd6260684b",
        "storage_key": "property/6767906449166549/019cfb4f-8b01-72a6-9dc5-cdcd6260684b.webp",
        "width": 500,
        "height": 571
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Find Apartments Near Pawnee Prairie Park",
      "seo_description": "Discover Silver Springs apartments near Pawnee Prairie Park in Sedgwick County. Enjoy modern living close to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5213"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-JJVDFDML2E"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18128852965"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/silver-springs/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WKHL74CK"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449166549/019d1bd6-2367-746c-b456-95a3cbd78eac.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "31277355030"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "8f12e41f-d192-4a39-9b6e-cac28efd1321"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "866-621-7738"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6500828ceb644678448e3d1d"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlYxWjdkL2kvWGp1VHphc3psNGwyR3c9PSIsInZhbHVlIjoiZ1lEZmoxdWZvS2VkUXNITDBvQmpXdz09IiwibWFjIjoiM2UxMGVhZDg1MTcxZTM4ZGNmZjJjODRjYjVlNzQ1NDQ0NjZlZjNmNmM5MWUzZTJhZGE1ZTA2ZjBkMDBlZjYyNSJ9"
    }
  ],
  "custom_qb_id": "5213",
  "custom_ga4_id": "G-JJVDFDML2E",
  "custom_repli_id": "18128852965",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/silver-springs/register/",
  "custom_google_gtm_id": "GTM-WKHL74CK",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449166549/019d1bd6-2367-746c-b456-95a3cbd78eac.pdf",
  "custom_hubspot_company_id": "31277355030",
  "custom_rentgrata_property_id": "8f12e41f-d192-4a39-9b6e-cac28efd1321",
  "custom_ppc_tracking_phone_number": "866-621-7738",
  "custom_residentboost_apartment_id": "6500828ceb644678448e3d1d",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlYxWjdkL2kvWGp1VHphc3psNGwyR3c9PSIsInZhbHVlIjoiZ1lEZmoxdWZvS2VkUXNITDBvQmpXdz09IiwibWFjIjoiM2UxMGVhZDg1MTcxZTM4ZGNmZjJjODRjYjVlNzQ1NDQ0NjZlZjNmNmM5MWUzZTJhZGE1ZTA2ZjBkMDBlZjYyNSJ9"
};

export const generatedAt = '2026-08-27T21:34:06.349Z';
